import {
  Box,
  Collapse,
  Grid,
  IconButton,
  Link,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Header from "../../common/Header";
import Card from "../../common/Card";
import Table from "../../common/CustomTable";
import {
  AddCircleOutlineOutlined,
  AppRegistrationOutlined,
  BoltOutlined,
  HistoryOutlined,
  ListAltOutlined,
  SearchOutlined,
  TroubleshootOutlined,
  UTurnLeftOutlined,
  AssignmentTurnedInOutlined,
  ReceiptLongOutlined,
  VisibilityOutlined,
  EditNoteOutlined,
  RemoveShoppingCartOutlined,
  ReplayOutlined,
  CloudDownload,
  PictureAsPdfOutlined,
  TrackChanges,
  ContentPasteOutlined,
  DownloadOutlined,
  KeyboardArrowDown,
  ExitToApp,
  LocalShippingOutlined,
  NotificationsOutlined,
  Notifications,
  Create,
  AssignmentReturnedOutlined,
  ShoppingCartOutlined,
} from "@mui/icons-material";
import Button from "../../common/Button";
import { useLocation, useNavigate } from "react-router-dom";
import CustomTextField from "../../common/CustomTextField";
import { useForm } from "react-hook-form";
import {
  OrderInfo,
  SearchOrder,
  hasOutsideOrderItemPayment,
  fetchOrderDocumentById,
  fetchOrdersList,
  resetOrderListInfo,
  useOrderSlice,
  fetchProductListIncludingInactiveByUserRoleOrderSlice,
  getPracticeListByUserRoleOrderSlice,
  cancelOrder,
  resetCancelStatus,
  previewPackagePDF,
  previewSalesPDF,
  previewProofOfDelivery,
  previewEvaltionForm,
  previewPrescriptionPDF,
  previewCMSPDF,
  getOrderTrackingLogs,
  getPracticeListByUserRoleOrderSlicenew,
  fetchAllProductListByUserRoleOrderSlice,
} from "../../../redux/slice/order/OrderSlice";
import LegacyToolBar from "../../common/LegacyToolBar";
import { useEffect, useMemo, useState } from "react";
import { PracticeInfo, PracticeInfonew } from "../../../redux/slice/practiceSlice";
import { AUDIT_ENTITYS, CAN_ACCESS_APPLICATION, EXPORTABLE_ITEMS, ORDERTYPE, ORDER_ACTIONS, ORDER_INVOICE_STATUS, ORDER_IVR_STATUS, ORDER_STATUS, PRODUCT_STATUS, EXPORT_ACTIONS, USER_ROLES, PRODUCT_CATEGORY, ORDER_AVAILABILITY, USER_ROLE_ENTITY_NAMES, PATIENT_LIST_ACTIONS } from "../../../constants/applicationConstants";
import { formatDate, formatShippingTrackingDateTime, formatShippingTrackingExpectedDateTime, getCategoryDisplayLabel, hideElement, sortNames } from "../../../utils/Utility";
import { createListSort } from "../../../utils/listSort";
import { asEntityNumber, buildActivityCenterPath } from "../../../utils/activityCenterUtils";
import {
  selectIsTokenAvailable,
  selectIsValueFoundInToken,
  selectTokenValues,
  useAuthSlice,
} from "../../../redux/slice/authSlice";
import { ProductInfo } from "../../../redux/slice/product/productListSlice";
import React from "react";
import CustomMultipleDropDown from "../../common/CustomMultipleDropDown";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import CustomDatePicker from "../../common/CustomDatePicker";
import moment from "moment";
import CreateOrderIVRListPopup from "./CreateOrderIVRListPopup";
import CustomIconButton from "../../common/CustomIconButton";
import PDFViewer from "../../common/pdf/PDFViewer";
import {
  fetchManufacturersListSkipLoading,
  setSingleAlertObj,
  showHideLoadingDialog,
  SingleAlertInfo,
  useCommonReducer,
} from "../../../redux/slice/commonSlice";
import {
  getSearchCriteriaFromSessionStorage,
  saveSelectionForPage,
  setSearchCriteriaToSessionStorage,
} from "../../../utils/StorageUtils";
import { tokens } from "../../../theme";
import CustomDateRange from "../../common/CustomDateRange";
import { DateObject } from "react-multi-date-picker";
import OptionsPopup, { OptionPopupObjectProps } from "../../common/OptionsPopup";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExportToExcel from "../../common/ExportToExcel";
import CustomDropdownField from "../../common/CustomDropdownFiled";
import RecordPastOrderPopup from "./RecordPastOrderPopup";
import { filter } from "jszip";
import InfoPopup from "../../common/InfoPopup";
import { useNavigation } from "../../../hooks/useNavigation";
import { useFilterPanelFocus } from "../../../hooks/useFilterPanelFocus";
import StyledMenu from "../../common/StyledMenu";
import ShipmentInfoPopup from "./ShipmentInfoPopup";
import { fetchActivePracticeProviders, getAllProviders, usePracticeProvidersSlice } from "../../../redux/slice/practice/practiceProvidersSlice";
import StatusInfoPopup from "../../common/StatusInfoPopup";
import { acknowledgeNotification, fetchAlertEntityNumbers, fetchNotificationsByRefEntities, useCreateNotificationSlice } from "../../../redux/slice/inbox/createNotificationSlice";
import SignOrderPopup from "./SignOrderPopup";
import dayjs from "dayjs";
import { useCodetablesSlice } from "../../../redux/slice/codetableSlice";
import OrderProductModal from "../account/OrderProductModal";
import { useModalStyles } from "../../common/useModalStyles";
// import { useBranding } from "../../../BrandingContext";

interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: "right" | "center" | "left";
  format?: (value: number) => string;
}

interface Row {
  orderNumber: string | JSX.Element; 
  rawOrderNumber?: string | number; // CS-1517 - For custom sorting
  practiceName: string;
  patientName: string;
  manufacturerName: string;
  productName: string;
  providerName: string;
  orderDate: string;
  dateOfService: string;
  orderType: string;
  orderStatus: string | JSX.Element; 
  invoiceStatus?: JSX.Element; // Optional if this might be hidden
  action: JSX.Element | null;
  shippingCarrier: string;
}

type Option = {
  value: string;
  label: string;
};

interface ShipmentInfo {
  show: boolean;
  orderId: number;
  orderNumber: string;
  trackingNumber: string;
  shipping_Info: any;
  status: string;
  carrierName: string;
  shippingDate: string;
  departureTime: string;
  expectedArrival: string;
  events: [];
  milestones: [];
  actualDeliveryTime: string;
}


const ITEMS_PER_PAGE = 20;

const orderListSort = createListSort(
  ["orderNumber", "practiceName", "patientName", "orderDate", "dateOfService", "manufacturerName", "productName", "providerName", "orderStatus"] as const,
  {
    orderNumber: "orderNumber",
    practiceName: "practiceName",
    patientName: "patientName",
    orderDate: "orderDate",
    dateOfService: "dateOfService",
    manufacturerName: "manufacturerName",
    productName: "productName",
    providerName: "providerName",
    orderStatus: "orderStatus",
  }
);

const OrderList = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { navigate } = useNavigation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isDark = theme.palette.mode === "dark";
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { primaryBtnSx, tokens: modalTokens } = useModalStyles();

  const {
    control,
    reset,
    watch,
    setValue,
    getValues,
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm<SearchOrder>();

  const [showCard, setShowCard] = useState(false);
  const {
    filterPanelRef,
    toggleFilterPanel,
    handleFilterPanelEntering,
    handleFilterPanelEntered,
    handleFilterPanelExited,
  } = useFilterPanelFocus(showCard, setShowCard);
  const [orderModalOpen, setOrderModalOpen] = useState(false);
  const [showIVRListPopup, setShowIVRListPopup] = useState(false);
  const [showPDF, setShowPDF] = useState<{
    isShow: boolean;
    productName: string;
    fileName: string;
  }>({ isShow: false, productName: "", fileName: "" });

  const [isDateRangeChanged, setIsDateRangeChanged] = useState(false);
  const [isDateRangeServiceChanged, setIsDateRangeServiceChanged] =
    useState(false);
  const [isClearDateRange, setIsClearDateRange] = useState(false);

  const [searchCriteria, setSearchCriteria] = useState<SearchOrder>({
    practiceIds: [],
    productIds: [],
    manufacturerIds: [],
    // CS-905
    patientFirstName: "",
    patientLastName: "",
    //
    providerName: "",
    orderNumber: "",
    invoiceNumber: "",
    serialNumber: "",
    // dateOfOrder: "",
    //cs-387
    fromDate: "",
    toDate: "",
    //
    // dateOfService: "",
    status: [],
    invoiceStatus: [],
    currentPage: 1,
    itemsPerPage: ITEMS_PER_PAGE,
    downloadState: false,
    orderItemStatus: [],
    fromServiceDate: "",
    toServiceDate: "",
    withoutIvr: "",
    alertOrders: false
  });

  const { userInfo } = useAuthSlice();
  const { allCodeTablesValuesMap } = useCodetablesSlice();
  const {
    orderListInfo,
    orderDocumentInfo,
    productsByUserRoleOrderSlice,
    allProductsByUserRoleOrderSlice,//CS-1564
    practiceByUserRoleOrderSlice,
    practiceByUserRoleOrderSlicenew,
    cancelStatus,
  } = useOrderSlice();

  const { manufacturerInfoList } = useCommonReducer();
  const { NotificationInfoByRefEntity} = useCreateNotificationSlice();

  const [isConfirmationOpen, setIsConfirmationOpen] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<OrderInfo>();
  const [showRecordPastOrderPopup, setShowRecordPastOrderPopup] = useState(false);
  const [alertedOrderIds, setAlertedOrderIds] = useState<number[]>([]);
  const [notificationData, setNotificationData] = useState<any[]>([]);

  const canCreateConsignmentOrder = useSelector((state: RootState) => selectIsTokenAvailable("canCreateConsignmentOrder")(state));
  // const canCreateDirectOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.CREATE_ORDER)(state));
  const canRecordPastOrder = useSelector((state: RootState) => selectIsTokenAvailable("canRecordPastOrder")(state));
  const canAccessOrderActions = useSelector((state: RootState) => selectIsTokenAvailable("canAccessOrderActions")(state));
  const canReturnOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.RETURN)(state));
  const canTrackOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.TRACKING)(state));
  const canDetailOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.DETAILS)(state));
  const canFulfilOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.FULFILL)(state));
  const canManageReturn = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.MANAGE_RETURN)(state));
  const canBillOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.BILLING)(state));
  const canSignOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.SIGNORDER)(state));
  const canViewHiddenOrderColumns = useSelector((state: RootState) => selectTokenValues("canViewHiddenOrderColumns")(state));
  const canCreateOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.CREATE_ORDER)(state));
  const canReOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.REORDER)(state));
  const canCancelOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.CANCEL)(state));
  const canAccessActivityCenter = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.ACTIVITY_CENTER)(state));
  const canAuditOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessAuditAction", AUDIT_ENTITYS.USERAUDIT)(state));
  const canAccessExportSSDetail = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessExportExcel", EXPORT_ACTIONS.EXPORT_SS_DETAIL)(state));
  const canAccessProviderProducts = useSelector((state: RootState) => selectTokenValues("canAccessProviderProducts")(state));
  const canExportList = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessExportExcel", EXPORTABLE_ITEMS.ORDER)(state));
  const accessibleNotifications = useSelector((state: RootState) => selectTokenValues("canAccessNotifications")(state));
  const canAccessNotifications = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessApplication", CAN_ACCESS_APPLICATION.NOTIFICATION_MANAGEMENT)(state));
  
  const [totalNotificationIds, setTotalNotificationIds] = useState([]);

  const [filterApplied, setFilterApplied] = useState(false);
  const [anchorElMenu, setAnchorElMenu] = useState<null | HTMLElement>(null);
    //CS-1071 - Start
    const [activeButtonId, setActiveButtonId] = useState<string | null>(null);
    //CS-1071 - End
  const [filteredeProductsByUserRoleOrderSlice, setFilteredeProductsByUserRoleOrderSlice] = useState<ProductInfo[]>();
  const [showCreateOrderPopup, setCreateOrderPopup] = useState<{message:string, show: boolean, title: string}>({message: "", show: false, title: "" });
  const [shipmentInfo, setShipmentInfo] = useState<ShipmentInfo>({
    show: false,
    orderId: 0,
    orderNumber: '',
    trackingNumber: '',
    shipping_Info: '',
    status: '',
    carrierName: '',
    shippingDate: '',
    departureTime: '',
    expectedArrival: '',
    events: [],
    milestones: [],
    actualDeliveryTime: ''
  });
  const { getProviderList , practiceProvidersInfo } = usePracticeProvidersSlice();
  const watchedPracticeIds = watch("practiceIds");
  const [statusAnchorEl, setStatusAnchorEl] = useState<HTMLElement | null>(null);
  const [statusInfo, setStatusInfo] = useState<{ orderNumber: string; orderStatus: string }>({
    orderNumber: "",
    orderStatus: "",
  });
  const [isAlertOnly, setIsAlertOnly] = useState<boolean>(false);
  //CS-1302 - Start
  const [showSignOrderPopup, setShowSignOrderPopup] = useState<boolean>(false);
  const [selectedOrderData,setSelectedOrderData] = useState<OrderInfo | null>(null);
  //CS-1302 - End
  
  //CS-1309 - Start
    // const branding = useBranding();
    // const { orderStatusLabels } = branding || {};
    //CS-1309 - End

  const getStatusColor = (status: string): string => {
    switch (status) {
      case ORDER_STATUS.DELIVERED: return "#4caf50";
      case ORDER_STATUS.PLACED: return isDark ? "#e2e8f0" : "#1e293b";
      case ORDER_STATUS.PENDING: return "#ff9800";
      case ORDER_STATUS.SHIPPED: return "#00B8D9";
      case ORDER_STATUS.CANCELED: return "#f44336";
      case ORDER_STATUS.PROCESSING: return "#ab47bc";
      default: return isDark ? "#e2e8f0" : "#1e293b";
    }
  };

  const listBorderColor = isDark ? "rgba(148,163,184,0.2)" : "rgba(15,23,42,0.12)";
  const listPanelBg    = isDark ? "#141720" : "rgba(255,255,255,0.82)";
  const listHoverBg    = isDark ? "rgba(20,184,166,0.09)" : "rgba(20,184,166,0.06)";

  const listCardSx = {
    borderRadius: "14px",
    border: `1px solid ${listBorderColor}`,
    backgroundColor: listPanelBg,
    backgroundImage: "none",
    backdropFilter: "blur(8px)",
    boxShadow: isDark ? "0 12px 32px rgba(0,0,0,0.28)" : "0 12px 28px rgba(15,23,42,0.08)",
  };

  const filterPanelSx = {
    ...listCardSx,
    p: { xs: "14px !important", md: "18px !important" },
    position: "relative",
    zIndex: 20,
    overflow: "visible",
    "& .MuiAutocomplete-root, & .MuiFormControl-root": { width: "100%" },
    "& .MuiTextField-root": { height: "42px", minHeight: "42px !important" },
    "& .MuiOutlinedInput-root, & .MuiInputBase-root, & .MuiAutocomplete-inputRoot, & .MuiAutocomplete-root .MuiOutlinedInput-root": {
      minHeight: "42px !important",
      height: "42px !important",
      borderRadius: "10px !important",
      backgroundColor: `${modalTokens.inputBg} !important`,
      color: modalTokens.textPrimary,
      fontSize: "0.88rem",
      boxShadow: isDark ? "none" : "0 1px 3px rgba(0,0,0,0.06)",
      alignItems: "center",
      boxSizing: "border-box",
    },
    "& .MuiAutocomplete-root .MuiOutlinedInput-root": { padding: "0 38px 0 12px !important" },
    "& .MuiAutocomplete-root .MuiInputBase-input, & .MuiAutocomplete-input, & .MuiOutlinedInput-input": {
      paddingTop: "8px !important",
      paddingBottom: "8px !important",
      height: "24px !important",
      lineHeight: "24px !important",
      boxSizing: "border-box",
    },
    "& .MuiOutlinedInput-input": { paddingLeft: "12px !important", paddingRight: "12px !important" },
    "& .MuiAutocomplete-endAdornment": { top: "50% !important", transform: "translateY(-50%)", right: "8px !important" },
    "& .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root fieldset": { borderColor: `${modalTokens.inputBorder} !important` },
    "& .MuiOutlinedInput-root:hover fieldset, & .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: `${modalTokens.accent} !important`, borderWidth: "1px !important" },
    "& .MuiOutlinedInput-root.Mui-focused": { boxShadow: isDark ? "none" : "0 0 0 3px rgba(20,184,166,0.12)" },
    "& .MuiInputBase-input": { color: modalTokens.textPrimary, fontSize: "0.88rem" },
    "& input::selection": { color: modalTokens.textPrimary, backgroundColor: isDark ? "rgba(20,184,166,0.28)" : "rgba(20,184,166,0.2)" },
    "& .MuiOutlinedInput-root:has(input:-webkit-autofill)": { backgroundColor: "#376c9f !important", "& fieldset": { borderColor: "#7fb1df !important" } },
    "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus": { WebkitTextFillColor: "#ffffff", caretColor: "#ffffff", WebkitBoxShadow: "0 0 0 100px #376c9f inset", borderRadius: "10px", transition: "background-color 5000s ease-in-out 0s" },
    "& .MuiInputLabel-root": { color: isDark ? "rgba(255,255,255,0.5)" : "rgba(0,0,0,0.45)", fontSize: "0.88rem" },
    "& .MuiInputLabel-root.Mui-focused": { color: `${modalTokens.accent} !important` },
    "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": { transform: "translate(14px, 9px) scale(1)" },
    "& .MuiChip-root": { borderRadius: "999px", backgroundColor: isDark ? "rgba(20,184,166,0.16)" : "rgba(20,184,166,0.1)", color: modalTokens.accent, border: `1px solid ${isDark ? "rgba(20,184,166,0.26)" : "rgba(20,184,166,0.18)"}`, fontWeight: 600 },
    "& .MuiSvgIcon-root": { color: modalTokens.textSecondary },
    "& .rmdp-container": { width: "100%", height: "42px", overflow: "visible", zIndex: 30 },
    "& .rmdp-wrapper, & .rmdp-calendar, & .rmdp-day-picker": { height: "auto !important", minHeight: "unset !important", overflow: "visible" },
    "& .rmdp-wrapper": { zIndex: "1600 !important", position: "absolute" },
  };

  const filterFieldLabelSx = {
    fontSize: "0.8rem",
    fontWeight: 600,
    color: modalTokens.textSecondary,
    mb: 0.7,
    height: "16px",
    lineHeight: "16px",
  };

  const primaryActionBtnSx = {
    ...primaryBtnSx,
    color: "#fff",
    "& .MuiTypography-root": { color: "#fff", fontWeight: 700 },
    "& .MuiButton-startIcon": { color: "#fff" },
  };

  const outlineBtnSx = {
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.86rem",
    borderRadius: "10px",
    py: 1.05,
    px: 1.6,
    color: "#00B8D9",
    borderColor: "rgba(0,184,217,0.55)",
    backgroundColor: isDark ? "rgba(0,184,217,0.08)" : "rgba(0,184,217,0.04)",
    whiteSpace: "nowrap",
    "&:hover": { color: "#fff", borderColor: "#00B8D9", backgroundColor: "#00B8D9", boxShadow: "0 6px 22px rgba(0,184,217,0.28)" },
  };

  const exportBtnSx = {
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.86rem",
    borderRadius: "10px",
    py: 1.05,
    px: 1.6,
    color: "#14B8A6",
    borderColor: "rgba(20,184,166,0.55)",
    backgroundColor: isDark ? "rgba(20,184,166,0.08)" : "rgba(20,184,166,0.04)",
    whiteSpace: "nowrap",
    "& .MuiSvgIcon-root": {
      color: "#14B8A6",
    },
    "&:hover": {
      color: "#fff",
      borderColor: "#14B8A6",
      backgroundColor: "#14B8A6",
      boxShadow: "0 6px 22px rgba(20,184,166,0.28)",
      "& .MuiSvgIcon-root": {
        color: "#fff",
      },
    },
  };

  const filledTealBtnSx = {
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.86rem",
    borderRadius: "10px",
    py: 1.05,
    px: 1.6,
    color: "#fff",
    backgroundColor: "#00B8D9",
    border: "1px solid #00B8D9",
    whiteSpace: "nowrap",
    "& .MuiTypography-root": { color: "#fff" },
    "& .MuiButton-startIcon": { color: "#fff" },
    "&:hover": {
      backgroundColor: "#0099bb",
      borderColor: "#0099bb",
      boxShadow: "0 6px 22px rgba(0,184,217,0.35)",
    },
  };

  const exportMenuItemBtnSx = {
    justifyContent: "flex-start",
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.86rem",
    borderRadius: "8px",
    py: 1,
    px: 1.4,
    color: "#2dd4bf",
    borderColor: "rgba(45,212,191,0.35)",
    backgroundColor: isDark ? "rgba(20,184,166,0.13)" : "rgba(20,184,166,0.08)",
    boxShadow: "none",
    "& .MuiButton-startIcon": { mr: 1, "& svg": { fontSize: "18px" } },
    "&:hover": { color: "#fff", borderColor: "#2f9b8f", backgroundColor: "#2f9b8f", boxShadow: "0 10px 24px rgba(20,184,166,0.28)" },
    "&.Mui-disabled": { color: isDark ? "rgba(148,163,184,0.55)" : "rgba(100,116,139,0.7)", borderColor: isDark ? "rgba(148,163,184,0.18)" : "rgba(100,116,139,0.24)", backgroundColor: isDark ? "rgba(148,163,184,0.06)" : "rgba(100,116,139,0.06)" },
  };

  const orderTableSx = {
    "& .MuiTableContainer-root": { borderRadius: "12px", border: "none", backgroundColor: "transparent" },
    "& table": {  borderCollapse: "collapse", borderSpacing: 0 },
    "& .MuiTableCell-root": { borderBottom: `1px solid ${isDark ? "rgba(148,163,184,0.14)" : "rgba(15,23,42,0.08)"}`, py: 1.15, fontSize: "0.84rem" },
    "& .MuiTableHead-root .MuiTableCell-root": { height: "42px"  },
    "& .MuiTableHead-root .MuiTypography-root": { color: "#00B8D9 !important", fontSize: "0.78rem", fontWeight: 800, letterSpacing: "0.02em" },
    "& .MuiTableBody-root .MuiTableRow-root": { transition: "background-color 0.18s ease, box-shadow 0.18s ease" },
    "& .MuiTableBody-root .MuiTableRow-root:hover": { backgroundColor: `${listHoverBg} !important` },
    "& .MuiTableBody-root .MuiTableCell-root": { color: modalTokens.textPrimary, fontSize: "0.84rem" },
    "& .MuiTableBody-root .MuiTypography-root": { fontSize: "0.84rem" },
    "& .MuiTableBody-root .MuiTableCell-root:first-of-type .MuiLink-root": { color: "#00B8D9 !important", fontWeight: 600, textDecorationColor: "rgba(0,184,217,0.45)" },
    "& .MuiTableBody-root .MuiTableCell-root:first-of-type .MuiLink-root:hover": { color: "#22d3ee !important", textDecorationColor: "#22d3ee" },
    "& .MuiIconButton-root": { color: isDark ? "#94a3b8" : "#475569", borderRadius: "8px", "&:hover": { color: modalTokens.accent, backgroundColor: isDark ? "rgba(20,184,166,0.12)" : "rgba(20,184,166,0.08)" } },
    "& .MuiPaginationItem-root": { borderColor: listBorderColor, color: modalTokens.textSecondary, borderRadius: "8px", "&.Mui-selected": { color: "#fff", backgroundColor: modalTokens.accent, borderColor: modalTokens.accent } },
  };
   
    //CS-1071 - Start
    useEffect(() => {
      const saved = sessionStorage.getItem("activeActionButtonId");
      if (saved) {
        setActiveButtonId(saved);
      }
    }, []);
    //CS-1071 - End 
    //CS-1564 - New api called to get all inactive products
  // useEffect(() => {
  //   const accessibleProductIds = canAccessProviderProducts[0] ? canAccessProviderProducts[0].split(',') : [];
  //   if(canAccessProviderProducts){
  //     if (accessibleProductIds && accessibleProductIds.length > 0) {
  //       const filteredProducts = productsByUserRoleOrderSlice.filter((product) =>
  //         accessibleProductIds.includes(product.productId.toString())  
  //       );
  //       setFilteredeProductsByUserRoleOrderSlice(filteredProducts);
  //     } else {
  //       setFilteredeProductsByUserRoleOrderSlice([])
  //     }
  //   }else{
  //     setFilteredeProductsByUserRoleOrderSlice(productsByUserRoleOrderSlice);
  //   }
  // }, [productsByUserRoleOrderSlice, canAccessProviderProducts]);
  useEffect(() => {
    const accessibleProductIds = canAccessProviderProducts[0] ? canAccessProviderProducts[0].split(',') : [];
    if(canAccessProviderProducts){
      if (accessibleProductIds && accessibleProductIds.length > 0) {
        const filteredProducts = allProductsByUserRoleOrderSlice.filter((product) =>
          accessibleProductIds.includes(product.productId.toString())  
        );
        setFilteredeProductsByUserRoleOrderSlice(filteredProducts);
      } else {
        setFilteredeProductsByUserRoleOrderSlice([])
      }
    }else{
      setFilteredeProductsByUserRoleOrderSlice(allProductsByUserRoleOrderSlice);
    }
  }, [allProductsByUserRoleOrderSlice, canAccessProviderProducts]);

  const handleMenuClose = () => {
    setAnchorElMenu(null);
  };
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMenu(event.currentTarget);
  };

  const updateCriteria = (key: string, value: number[]) => {
    const sessionName = CAN_ACCESS_APPLICATION.ORDER_MANAGEMENT + "SearchCriteria" + userInfo.userId;
    //@ts-ignore
    setValue(key, value);
    let criteria = getSearchCriteriaFromSessionStorage(sessionName);
    const updated = { ...criteria, [key]: value };
    setSearchCriteriaToSessionStorage(sessionName, updated);
    setSearchCriteria(updated);
  };

  const manufacturesList = useMemo(() => {
    let options: { label: string; value: any }[] = [];

    if ((filteredeProductsByUserRoleOrderSlice?.length ?? 0) > 0 && manufacturerInfoList?.length > 0) {
      const uniqueManufacturerIds = (filteredeProductsByUserRoleOrderSlice ?? [])
        .map((product) => product.manufacturerId)
        .filter((id, index, self) => id !== null && self.indexOf(id) === index);
  
      const filteredManufacturers = manufacturerInfoList.filter((manufacturer) =>
        uniqueManufacturerIds.includes(manufacturer.manufacturerId) 
      );

      if (manufacturerInfoList.length === 1) {
        const mfgVal = [Number(manufacturerInfoList[0]?.manufacturerId)];
        updateCriteria('manufacturerIds', mfgVal);
      }
      //CS-1564 - Show INACTIVE with manufacturers label
      //  filteredManufacturers.forEach((item) => {
      //   options.push({
      //     label: item.manufacturerName,
      //     value: item.manufacturerId,
      //   });
      // });
      filteredManufacturers.forEach((item) => {
        const isInactive =
          item?.inactiveDate &&
          dayjs(item.inactiveDate).isBefore(dayjs(), "day");

        options.push({
          label: isInactive
            ? `${item.manufacturerName} (INACTIVE)`
            : item.manufacturerName,
          value: item.manufacturerId,
        });
      });

    }
  
    return options;
  }, [filteredeProductsByUserRoleOrderSlice, manufacturerInfoList]);  

  const hiddenColumns = useMemo(() => {
    let cols: Column[] = [
      { id: "invoiceStatus", label: "Invoice Status", minWidth: 100 },
    ];
    return cols;
  }, []);
  const columns = useMemo(() => {
    let cols: Column[] = [
      { id: "orderNumber", label: "Order ID", minWidth: 100 },
      { id: "practiceName", label: "Practice", minWidth: 100 },
      { id: "patientName", label: "Patient", minWidth: 100 },
      { id: "manufacturerName", label: "Manufacturer", minWidth: 100 },
      { id: "productName", label: "Product", minWidth: 100 },
      { id: "providerName", label: "Provider", minWidth: 100 },
      { id: "orderDate", label: "Order Date", minWidth: 100 },
      { id: "dateOfService", label: "Date Of Service", minWidth: 100 },
      // { id: "orderType", label: "Order Type", minWidth: 100 },
      { id: "orderStatus", label: " Order Status", minWidth: 100 }, //CS-1259 mpm changes
      { id: "trackingNumber", label: "Track", minWidth: 100 },
    ];
    canViewHiddenOrderColumns &&
      canViewHiddenOrderColumns.forEach((colId) => {
        const hideCol = hiddenColumns.find((col) => col.id == colId);
        if (hideCol) {
          cols.push(hideCol);
        }
      });
    cols.push({ id: "action", label: "Action", minWidth: 50 });
    return cols;
  }, [canViewHiddenOrderColumns]);

  const statusOptions = useMemo(() => {
    let options: { label: string; value: any }[] = [
      //CS-1309 - Start
      // { value: PRODUCT_STATUS.PLACED, label: orderStatusLabels?.PLACED },
      //CS-1309 - end
      { value: PRODUCT_STATUS.PLACED, label: PRODUCT_STATUS.PLACED },
      { value: PRODUCT_STATUS.PENDING, label: PRODUCT_STATUS.PENDING },
      { value: PRODUCT_STATUS.SHIPPED, label: PRODUCT_STATUS.SHIPPED },
      { value: PRODUCT_STATUS.DELIVERED, label: PRODUCT_STATUS.DELIVERED },
      { value: PRODUCT_STATUS.CANCELED, label: PRODUCT_STATUS.CANCELED },
      { value: PRODUCT_STATUS.PROCESSING, label: PRODUCT_STATUS.PROCESSING },
      { value: PRODUCT_STATUS.DELAYED, label: PRODUCT_STATUS.DELAYED },
    ];
    return options;
  }, []);

  //CS-1164 START
  const availabilityOptions = useMemo(() => {
    let options: { label: string; value: any }[] = [
      { value: ORDER_AVAILABILITY.AVAILABLE, label: "AVAILABLE" },
      { value: ORDER_AVAILABILITY.APPLIED, label: "APPLIED" },
      { value: ORDER_AVAILABILITY.RETURN_INITIATED, label: "RETURN INITIATED" },
      { value: ORDER_AVAILABILITY.RETURN_PENDING, label: "RETURN PENDING" },
      { value: ORDER_AVAILABILITY.RETURNED, label: "RETURNED" },
      { value: ORDER_AVAILABILITY.RETURN_REJECTED, label: "RETURN REJECTED" }
    ];
    return options;
  }, []);
  //CS-1164 END

  const orderInvoiceStatusOptions = useMemo(() => {
    let options: { label: string; value: any }[] = [
      {
        value: ORDER_INVOICE_STATUS.PENDING,
        label: ORDER_INVOICE_STATUS.PENDING,
      },
      {
        value: ORDER_INVOICE_STATUS.PARTIAL,
        label: ORDER_INVOICE_STATUS.PARTIAL,
      },
      {
        value: ORDER_INVOICE_STATUS.INVOICED,
        label: ORDER_INVOICE_STATUS.INVOICED,
      },
    ];
    return options;
  }, []);

  const includeIvrOptions = useMemo(() => {
    let options: { label: string; value: any }[] = [
      { value: ORDER_IVR_STATUS.WITH_IVR, label: "Verified In Platform" },
      { value: ORDER_IVR_STATUS.WITHOUT_IVR, label: "Verified Outside Platform" },
    ];
    return options;
  }, []);

  const practiceOptions = useMemo(() => {
    let options: Option[] = [];
    if (
      practiceByUserRoleOrderSlicenew &&
      practiceByUserRoleOrderSlicenew.length > 0
    ) {
      if (practiceByUserRoleOrderSlicenew.length === 1) {
        const practiceVal = [Number(practiceByUserRoleOrderSlicenew[0]?.practiceId)];
        updateCriteria('practiceIds', practiceVal);
      }
      const sortedPracticeInfo: PracticeInfo[] = sortNames(
        practiceByUserRoleOrderSlicenew,
        "practiceName"
      );
      sortedPracticeInfo?.map((practice) => {
        options.push({
          value: practice.practiceId,
          label: practice.practiceName,
        });
      });
    }
    return options;
  }, [practiceByUserRoleOrderSlicenew]);

  const productOptions = useMemo(() => {
    let options: Option[] = [];
    if (
      filteredeProductsByUserRoleOrderSlice &&
      filteredeProductsByUserRoleOrderSlice.length > 0
    ) {
      if (filteredeProductsByUserRoleOrderSlice.length === 1) {
        const productVal = [Number(filteredeProductsByUserRoleOrderSlice[0]?.productId)]
        updateCriteria('productIds', productVal);
      }
      const sortedProductList: ProductInfo[] = sortNames(
        filteredeProductsByUserRoleOrderSlice,
        "productName"
      );
      //CS-1564 - Show INACTIVE products in dropdown and label is customized
      // sortedProductList?.map((option) => {
      //   options.push({ label: option.productName, value: option.productId });
      // });
      sortedProductList?.map((option) => {
        const isInactive =
          option?.inactiveDate &&
          dayjs(option.inactiveDate).isBefore(dayjs(), 'day');

        options.push({
          label: isInactive
            ? `${option.productName} (INACTIVE)`
            : option.productName,
          value: option.productId,
        });
      });

    }
    return options;
  }, [filteredeProductsByUserRoleOrderSlice]);

  //Mount
  useEffect(() => {
    fetchInitialLists();
    const orderDocId = location.state?.orderDocId;
    const tissueTrackingDocId = location.state?.tissueTrackingDocId;
    const productReturnDocId = location.state?.productReturnDocId;
    const orderNumber = location.state?.orderNumber;
    if (orderNumber) {
      setValue("orderNumber", orderNumber);
    }
    if (orderDocId || tissueTrackingDocId || productReturnDocId) {
      previewDoc(orderDocId || tissueTrackingDocId || productReturnDocId);
    }
  }, []);

  useEffect(() => {
    const fechManufacturers = async () =>{
      const res = await dispatch(fetchManufacturersListSkipLoading({skipLoader: true}));
    }
    fechManufacturers();
  }, []);

  const previewDoc = async (docId: string) => {
    const actionResult = await dispatch(
      fetchOrderDocumentById(parseInt(docId))
    );
    const documentData = actionResult.payload;

    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: docId + ` - Order`,
        fileName: docId,
      });
    }
  };

  const fetchInitialLists = async () => {
    dispatch(showHideLoadingDialog(true));
    //Don't remove below unused variables
    const responsePractices = await dispatch(
      // getPracticeListByUserRoleOrderSlice(false)
       getPracticeListByUserRoleOrderSlicenew({isActivePracticeOnly: true, skipLoader: true})
    );
    const responseProducts = await dispatch(
      // fetchProductListIncludingInactiveByUserRoleOrderSlice({includeProductPrice: false, executedOnly: true, skipLoader: true})
      //CS-1564 - Calling new api to include inactive products
      fetchAllProductListByUserRoleOrderSlice({includeProductPrice: false, executedOnly: true, skipLoader: true})
    );
    dispatch(showHideLoadingDialog(false));
  };

  //Unmount
  useEffect(
    () => () => {
      dispatch(resetOrderListInfo());
    },
    []
  );

  useEffect(() => {
    const orderNumber = location.state?.orderNumber;
    if (orderNumber) {
      setShowCard(true);
      setValue("orderNumber", orderNumber);
      const data = {
        ...searchCriteria,
        orderNumber: orderNumber,
      };
      searchOrdersList(data);
    }
    //1. When login another user pagination is remain in the history and can redirect that page
    else {
      let criteria = getSearchCriteriaFromSessionStorage(
        CAN_ACCESS_APPLICATION.ORDER_MANAGEMENT +
          "SearchCriteria" +
          userInfo.userId
      );
      if (
        (location.state && location.state.orderListSearchCriteria) ||
        (location.state && location.state.withSearchHistory && criteria)
      ) {
        if (location.state && location.state.withSearchHistory) {
          //Below navigate line call back to this useEffect - This for refreshing issue when navigate with state.withSearchHistory=true
          navigate("/order_list", {
            state: {
              orderListSearchCriteria: criteria,
              cancelledOrderNumber: location.state?.cancelledOrderNumber,
            },
          });
          return;
        }
        let searchCriteria: SearchOrder = {
          practiceIds: [],
          manufacturerIds: [],
          // CS-905
          patientFirstName: "",
          patientLastName: "",
          //
          productIds: [],
          providerName: getValues('providerName') || "",
          orderNumber: "",
          invoiceNumber: "",
          serialNumber: "",
          // dateOfOrder: "",
          //cs-387
          fromDate: "",
          toDate: "",
          //
          // dateOfService: "",
          status: [],
          orderItemStatus: [],
          invoiceStatus: [],
          currentPage: 0,
          itemsPerPage: 0,
          downloadState: false,
          fromServiceDate: "",
          toServiceDate: "",
          withoutIvr: "",
          alertOrders: isAlertOnly ? true : false
        };
        if (location.state && location.state.orderListSearchCriteria) {
          location.state.orderListSearchCriteria.alertOrders = isAlertOnly ? true : false;
          searchCriteria = location.state.orderListSearchCriteria;
        } else {
          if(criteria){
            criteria.alertOrders = isAlertOnly ? true : false;
          }
          searchCriteria = criteria ? criteria : searchCriteria;
        }

        setSearchCriteria(searchCriteria);

        setValuesToCriteriaFields(searchCriteria);
        searchOrdersList(searchCriteria);
      } else {
        const dateRangeValue = getValues("dateRange");
        let fromDateRange = "";
        let toDateRange = "";

        if (dateRangeValue) {
          const dates = dateRangeValue.split(" - ");
          fromDateRange = dates[0] || "";
          toDateRange = dates[1] || "";
        }


        const fromServiceDateRange = getValues("fromServiceDate");
        const toServiceDateRange = getValues("toServiceDate");
        const providerName = getValues('providerName');

        const initialSearchCriteria = {
          ...searchCriteria,
          fromDate: fromDateRange || "",
          toDate: toDateRange || "",
          fromServiceDate: fromServiceDateRange || "",
          toServiceDate: toServiceDateRange || "",
          alertOrders: isAlertOnly ? true : false,
          providerName: providerName || ""
        };
        setSearchCriteria(initialSearchCriteria);
        // setValuesToCriteriaFields(initialSearchCriteria);
        if (
          fromDateRange ||
          toDateRange
        ) {
          searchOrdersList(initialSearchCriteria);
          setIsDateRangeChanged(false);
          setIsDateRangeServiceChanged(false);
        } else {
          loadInitialOrderList(1);
        }
      }
    }
  }, [location.state, isAlertOnly]);

  const setValuesToCriteriaFields = (searchCriteria: SearchOrder) => {
    setValue("practiceIds", searchCriteria.practiceIds);
    setValue("manufacturerIds", searchCriteria.manufacturerIds);
    setValue("productIds", searchCriteria.productIds);
    // CS-905
    setValue("patientFirstName", searchCriteria.patientFirstName);
    setValue("patientLastName", searchCriteria.patientLastName);
    //
    setValue("providerName", searchCriteria.providerName);
    // setValue("dateOfOrder", searchCriteria.dateOfOrder);
    //CS-387
    // setValue("fromDate", searchCriteria.fromDate);
    // setValue("toDate", searchCriteria.toDate);
    setValue("serialNumber", searchCriteria.serialNumber);
    //
    // setValue("dateOfService", searchCriteria.dateOfService);
    setValue("status", searchCriteria.status);
    setValue("orderItemStatus", searchCriteria.orderItemStatus);
    setValue("invoiceStatus", searchCriteria.invoiceStatus);

    // setValue("fromServiceDate", searchCriteria.fromServiceDate);
    // setValue("toServiceDate", searchCriteria.toServiceDate);

    setValue("orderNumber", searchCriteria.orderNumber);

    if (searchCriteria.fromDate && searchCriteria.toDate) {
      const fromDate = searchCriteria.fromDate || "";
      const toDate = searchCriteria.toDate || "";
      setValue(
        "dateRange",
        fromDate && toDate ? `${fromDate} - ${toDate}` : ""
      );
    } else if (searchCriteria.fromDate) {
      const fromDate = searchCriteria.fromDate || "";
      setValue(
        "dateRange",
        fromDate ? `${fromDate}` : ""
      );
    }

    if (searchCriteria.fromServiceDate && searchCriteria.toServiceDate) {
      const fromDate = searchCriteria.fromServiceDate || "";
      const toDate = searchCriteria.toServiceDate || "";
      setValue(
        "dateOfService",
        fromDate && toDate ? `${fromDate} - ${toDate}` : ""
      );
    } else if (searchCriteria.fromServiceDate) {
      const fromDate = searchCriteria.fromServiceDate || "";
      setValue(
        "dateOfService",
        fromDate ? `${fromDate}` : ""
      );
    }
  };

  const loadInitialOrderList = (pNumber: number = 1) => {
    const practiceIdList =
    practiceByUserRoleOrderSlicenew && practiceByUserRoleOrderSlicenew.length > 0
        ? practiceByUserRoleOrderSlicenew?.map((practice) =>
            Number(practice.practiceId)
          )
        : [];
    const productIdList =
    filteredeProductsByUserRoleOrderSlice && filteredeProductsByUserRoleOrderSlice.length > 0
        ? filteredeProductsByUserRoleOrderSlice?.map((product) =>
            Number(product.productId)
          )
        : [];
    const manufacturerIdsList = 
      manufacturerInfoList && manufacturerInfoList?.length > 0 
        ? manufacturerInfoList?.map((manufacturer) => 
          Number(manufacturer.manufacturerId)
        ) : [];
    const data: SearchOrder = {
      practiceIds:
        practiceIdList && practiceIdList.length === 1 ? practiceIdList : [],
      manufacturerIds:
        manufacturerIdsList && manufacturerIdsList.length === 1 ? manufacturerIdsList : [],
      productIds:
        productIdList && productIdList.length === 1 ? productIdList : [],
      // CS-905
      patientFirstName: "",
      patientLastName: "",
      //
      providerName: getValues('providerName') || "",
      orderNumber: "",
      invoiceNumber: "",
      serialNumber: "",
      // dateOfOrder: "",
      //cs-387
      fromDate: "",
      toDate: "",
      //
      // dateOfService: "",
      status: [],
      orderItemStatus: [],
      invoiceStatus: [],
      currentPage: pNumber,
      itemsPerPage: ITEMS_PER_PAGE,
      downloadState: false,
      fromServiceDate: "",
      toServiceDate: "",
      withoutIvr: "",
      alertOrders: isAlertOnly ? true : false,
    };
    setSearchCriteria(data);
    setValuesToCriteriaFields(data);

    searchOrdersList(data);
  };



  const searchOrdersList = (searchCriteria: SearchOrder) => {
    const normalizedCriteria = orderListSort.normalize(searchCriteria);
    setSearchCriteriaToSessionStorage(
      CAN_ACCESS_APPLICATION.ORDER_MANAGEMENT +
        "SearchCriteria" +
        userInfo.userId,
      normalizedCriteria
    );

    let dataToSearch = {
      ...normalizedCriteria,
    };
    // if (!dataToSearch.practiceIds || dataToSearch.practiceIds.length === 0) {
    //   dataToSearch.practiceIds =
    //   practiceByUserRoleOrderSlicenew && practiceByUserRoleOrderSlicenew.length > 0
    //       ? practiceByUserRoleOrderSlicenew?.map((practice) =>
    //           Number(practice.practiceId)
    //         )
    //       : [];
    // }
    // if (!dataToSearch.productIds || dataToSearch.productIds.length === 0) {
    //   dataToSearch.productIds =
    //   filteredeProductsByUserRoleOrderSlice && filteredeProductsByUserRoleOrderSlice.length > 0
    //       ? filteredeProductsByUserRoleOrderSlice?.map((product) =>
    //           Number(product.productId)
    //         )
    //       : [];
    // }
    // if (!dataToSearch.manufacturerIds || dataToSearch.manufacturerIds.length === 0) {
    //   dataToSearch.manufacturerIds =
    //     manufacturerInfoList && manufacturerInfoList.length > 0
    //       ? manufacturerInfoList?.map((manufacturer) =>
    //           Number(manufacturer.manufacturerId)
    //         )
    //       : [];
    // }
    if (!dataToSearch.status || dataToSearch.status.length === 0) {
      dataToSearch.status =
        statusOptions && statusOptions.length > 0
          ? statusOptions?.map((status) => status.value)
          : [];
    }
    if (!dataToSearch.orderItemStatus || dataToSearch.orderItemStatus.length === 0) {
      dataToSearch.orderItemStatus =
        availabilityOptions && availabilityOptions.length > 0
          ? availabilityOptions?.map((status) => status.value)
          : [];
    }
    if (
      !dataToSearch.invoiceStatus ||
      dataToSearch.invoiceStatus.length === 0
    ) {
      dataToSearch.invoiceStatus =
        orderInvoiceStatusOptions && orderInvoiceStatusOptions.length > 0
          ? orderInvoiceStatusOptions?.map((status) => status.value)
          : [];
    }
    if (userInfo.userRole !== USER_ROLES.ROLE_PRACTICE_USER_PRU) {
      dispatch(fetchOrdersList({ data: dataToSearch, skipLoader: false }));
    }
  };

  const onSubmit = (data: SearchOrder) => {
    if (!isDateRangeChanged) {
      setValue("fromDate", "");
      setValue("toDate", "");
      setValue("dateRange", "");
      setIsClearDateRange(true);
    }
    const data2: SearchOrder = {
      practiceIds: data.practiceIds || [],
      productIds: data.productIds || [],
      manufacturerIds: data.manufacturerIds || [],
      // CS-905
      patientFirstName: data.patientFirstName || "",
      patientLastName: data.patientLastName || "",
      //
      providerName: data.providerName || "",
      orderNumber: data.orderNumber || "",
      invoiceNumber: data.invoiceNumber || "",
      serialNumber: data.serialNumber || "",
      // dateOfOrder: data.dateOfOrder ? moment(data.dateOfOrder?.toString())?.format("MM/DD/YYYY") : "",
      //cs-387
      fromDate: isDateRangeChanged ? (data.fromDate || "") : "",
      toDate: isDateRangeChanged ? (data.toDate || "") : "",
      //
      // dateOfService: "",
      status: data.status || [],
      orderItemStatus: data.orderItemStatus || [],
      invoiceStatus: data.invoiceStatus || [],
      currentPage: 1,
      itemsPerPage: ITEMS_PER_PAGE,
      downloadState: false,
      fromServiceDate: isDateRangeServiceChanged ? (data.fromServiceDate || "") : "",
      toServiceDate: isDateRangeServiceChanged ? (data.toServiceDate || "") : "",
      withoutIvr: data.withoutIvr || "",
      ...orderListSort.pick(searchCriteria),
    };
    setSearchCriteria(data2);

    if (data2.practiceIds.length === 0 && data2.productIds.length === 0 && data2.manufacturerIds.length === 0 &&
      data2.patientFirstName === "" && data2.patientLastName === "" && data2.providerName === "" && data2.orderNumber === "" &&
      data2.invoiceNumber === "" && data2.serialNumber === "" && data2.status.length === 0 &&
      data2.invoiceStatus.length === 0 && data2.fromServiceDate === "" && data2.toServiceDate === "" &&
      data2.withoutIvr === ""
    ) {
      setFilterApplied(false);
    } else {
      setValue("fromDate", "");
      setValue("toDate", "");
      setValue("dateRange", "");
      setFilterApplied(true);
    }

    //Below navigate line call to useEffect[location.state, productsByUserRoleOrderSlice] and search
    navigate("/order_list", { state: { orderListSearchCriteria: data2 } });
  };

  const handlePagination = (pageNumber: number) => {
    const data = {
      ...searchCriteria,
      currentPage: pageNumber + 1,
    };
    setSearchCriteria(data);

    //Below navigate line call to useEffect[location.state, productsByUserRoleOrderSlice] and search
    navigate("/order_list", { state: { orderListSearchCriteria: data } });
  };

  const handleTableSort = (columnId: string, order: "asc" | "desc") => {
    const data = orderListSort.withSort(searchCriteria, columnId, order);
    if (!data) {
      return;
    }
    setSearchCriteria(data);
    navigate("/order_list", { state: { orderListSearchCriteria: data } });
  };

  const handleClose = () => {
    setShowIVRListPopup(false);
  };

  const handlePreviewAction = async (row: OrderInfo) => {
    const documentId = row.orderDocumentId ? row.orderDocumentId : 0;
    const actionResult = await dispatch(fetchOrderDocumentById(documentId));
    const documentData = actionResult.payload;

    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - ORDER`,
        fileName: row.orderNumber,
      });
    }
  };
  // CS - 922 - Start
  const handlePackagePreview = async (row: OrderInfo) => {
    const orderId = row.orderId ;
    const actionResult = await dispatch(previewPackagePDF(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - Packing List`,
        fileName: row.orderNumber+"_PackingList",
      });
    }
  };
  // CS - 922 - End

  // CS - 731 - Start
    const handleSalesInvoicePreviw = async (row: OrderInfo) => {
    const orderId = row.orderId ;
    const actionResult = await dispatch(previewSalesPDF(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - Sales Invoice`,
        fileName: row.orderNumber+"_SalesInvoice",
      });
    }
  };
  // CS - 731 - End
  // CS - 926 
    const handlePrescriptionPrview = async (row: OrderInfo) => {
    const orderId = row.orderId ;
    const actionResult = await dispatch(previewPrescriptionPDF(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - Prescription`,
        fileName: row.orderNumber+"_Prescription",
      });
    }
  };
  // 
  // CS - 934
    const handleCMSPrview = async (row: OrderInfo) => {
    const orderId = row.orderId ;
    const actionResult = await dispatch(previewCMSPDF(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - CMS 1500 Form`,
        fileName: row.orderNumber+"_CMS1500Form",
      });
    }
  };
  // 
  // CS - 936 - Start
    const handleProofOfDeliveryPreviw = async (row: OrderInfo) => {
    const orderId = row.orderId ;
    const actionResult = await dispatch(previewProofOfDelivery(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - Proof Of Delivery`,
        fileName: row.orderNumber+"_ProofOfDelivery",
      });
    }
  };
  // CS - 936 - End
  // CS - 927 - Start
    const handleEvaluationForm = async (row: OrderInfo) => {
    const orderId = row.orderId ;
    const actionResult = await dispatch(previewEvaltionForm(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - Assessment Form`,
        fileName: row.orderNumber+"_AssessmentForm",
      });
    }
  };
  // CS - 927 - End
//  CS-793
  const setPatientNavigationPopup = () => {
    setCreateOrderPopup({
      message: 'The "Create Order" function is moved to the new "Patients" section. From the "Patients" section, search for the patient or add a new patient, and then from the action menu, choose an option to "Create Order"',
      show: true,
      title: "Create Order"
    });
  };

  // CS-925
  const setPatientNavigationPopupforPastOrder = () => {
    setCreateOrderPopup({
      message: 'The "Record Order" function is moved to the new "Patients" section. From the "Patients" section, search for the patient or add a new patient, and then from the action menu, choose an option to "Record Past Order"',
      show: true,
      title: "Record Order"
    });
  };
  //
  const handleNavigate = (row: OrderInfo) => {
    if (row.orderType === ORDERTYPE.CONSIGNMENT_ORDER) {
      navigate("/create_consignment_order", { state: { selectedOrder: row } });
    } else {
      navigate("/tissue_tracking", { state: { selectedOrder: row } });
    }
  };

  const redirectToTheOrderFulfillment = (row: OrderInfo) => {
    navigate("/fulfill_order", { state: { selectedOrderDetail: row } });
  };

  //CS-1164
  const handleManageReturn = (row: OrderInfo) => {
    navigate("/manage_return", { state: { selectedReturnRequest: row } });
  };

  const handleBilling = (row: OrderInfo) => {
    navigate("/billing", { state: { selectedOrderBilling: row } });
  };
  //CS-1322 - Start
  const handleCreateInvoice = (row: OrderInfo) => {
    navigate("/create_invoice", { state: { selectedOrderBilling: row } });
  };
  //CS-1322 - End
  const handleActionDetails = (row: OrderInfo) => {
    const oNumber = row.orderNumber;
    if (oNumber?.startsWith("M")) {
      navigate("/migrate_details/1", { state: { orderDetails: row } });
    } else {
      navigate("/details/1", { state: { orderDetails: row } });
    }
  };

    const handleCancelAndReOrder = (row: OrderInfo) => {
    navigate("/order", {
      state: {
        orderType: ORDERTYPE.DIRECT_ORDER,
        orderDetails: row,
        isReorder: true,
        orderDate: row.orderDate,
      },
    });
  };

  const isOutsideOrder = (row?: OrderInfo) =>
    row?.isOutsideOrder === true ||
    row?.orderInfo?.isOutsideOrder === true ||
    row?.orderInfo?.isOutsideOrder === "true";

  const canUpdateOutsideOrder = (row?: OrderInfo) =>
    isOutsideOrder(row) && !hasOutsideOrderItemPayment(row);

  const handleEditOutsideOrder = (row: OrderInfo) => {
    navigate("/order", {
      state: {
        orderType: ORDERTYPE.PAST_ORDER,
        outsideOrderEditOrderId: row.orderId,
      },
    });
  };

  const handleCancelOrder = async (row: any) => {
    setSelectedRow(row);
    setIsConfirmationOpen(true);
  };

  const handleCancelOrderConfirmation = () => {
    if (selectedRow) {
      dispatch(cancelOrder(selectedRow.orderId));
      setIsConfirmationOpen(false);
    }
  };

  const handleCloseCancelOrderConfirmation = () => {
    setIsConfirmationOpen(false);
  };

  useEffect(() => {
    let message = "";
    const orderNumber = selectedRow?.orderNumber || location.state?.cancelledOrderNumber;

    if (cancelStatus === "success") {
      if (!orderNumber) {
        searchOrdersList(searchCriteria);
        dispatch(resetCancelStatus());
        return;
      }
      message = `Order ${orderNumber} canceled successfully.`;
      const alertObj: SingleAlertInfo = {
        message: message,
        alertType: "success",
      };
      dispatch(setSingleAlertObj(alertObj));
      searchOrdersList(searchCriteria);

      const timer = setTimeout(() => {
        dispatch(resetCancelStatus());
      }, 3000);

      return () => clearTimeout(timer);
    } else if (cancelStatus === "error") {
      if (!orderNumber) {
        dispatch(resetCancelStatus());
        return;
      }
      message = `Order ${orderNumber} cancelation unsuccessful.`;
      const alertObj: SingleAlertInfo = {
        message: message,
        alertType: "error",
      };
      dispatch(setSingleAlertObj(alertObj));

      const timer = setTimeout(() => {
        dispatch(resetCancelStatus());
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [cancelStatus, selectedRow, location.state, searchCriteria, dispatch]);
  //CS-518 Passing the Order details to audit log
  const handleClickOrderAudit = (data: any) => {
    if (data && data.orderNumber) {
      const OrderAuditData = {
        entityName: "ORDER",
        entityNumber: data?.orderNumber,
      };
      const url = `/auditlog?entityName=${OrderAuditData.entityName}&entityNumber=${OrderAuditData.entityNumber}`;
      window.open(url, "_blank");
    }
  };
  //

  const handleRowClick = (row: any) => {}; // CS-1555

    //CS-1071 - Start
    const handleActionButtonClick = (buttonId: string, originalClick: () => void) => {
      const currentPageKey = "orderList"; // Or dynamically set this value based on the current page
      saveSelectionForPage(currentPageKey, buttonId);
      setActiveButtonId(buttonId);
      sessionStorage.setItem("activeActionButtonId", buttonId);
      originalClick(); // Call the button's actual logic
    };
    //CS-1071 - End
  const actionComponent = (row: OrderInfo): JSX.Element | null => {
    //CS-1564 - Hide the action buttons if the order is inactive only show details and audit
    const hideAllActionsForInactiveOrder =
      (row?.manufacturerInactiveDate &&
        dayjs(row.manufacturerInactiveDate).isBefore(dayjs(), 'day')) || (row?.productInactiveDate &&
          dayjs(row.productInactiveDate).isBefore(dayjs(), 'day'));
    const showSignOrder =
      row?.customConfig?.provider_signature_required === "Y" &&
      row?.orderStatus === ORDER_STATUS.PENDING &&
      row.productCategory === PRODUCT_CATEGORY.CONSERVATIVE && // because the button later hides when != Collagen
      canSignOrder && row.canSignOrder === true;
    const conditions = [
      hideElement(!canDetailOrder),
      hideElement(!(canFulfilOrder && row?.orderStatus !== ORDER_STATUS.CANCELED)),
      hideElement(
        row.productCategory === PRODUCT_CATEGORY.CONSERVATIVE ||
        !canBillOrder ||
        row?.orderStatus !== ORDER_STATUS.DELIVERED ||
        row.invoiceStatus === "INVOICED"
      ),
      hideElement(
        row?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE ||
        !canReOrder ||
        row?.orderStatus !== ORDER_STATUS.PLACED
      ),
      hideElement(
        row.productCategory === PRODUCT_CATEGORY.CONSERVATIVE ||
        !(canTrackOrder && row?.orderStatus === ORDER_STATUS.DELIVERED)
      ),
      hideElement(
        row.productCategory === PRODUCT_CATEGORY.CONSERVATIVE ||
        !(canReturnOrder && row?.orderStatus === ORDER_STATUS.DELIVERED)
      ),
      hideElement(
        !canCancelOrder || !(
          row?.orderStatus === ORDER_STATUS.PLACED ||
          ((userInfo.entityName === USER_ROLE_ENTITY_NAMES.ADMIN && row?.orderStatus === ORDER_STATUS.PROCESSING && row?.trackingNumber === null) ||
              (userInfo.entityName === USER_ROLE_ENTITY_NAMES.ADMIN && row?.orderStatus === ORDER_STATUS.PROCESSING))
          )
        ),
      hideElement(!canAuditOrder),
      hideElement(!showSignOrder),
      hideElement(!canUpdateOutsideOrder(row)),
      hideElement(!canAccessActivityCenter),
      ];

    if (conditions.every(display => display === "none")) return null;

    return (
      <>
        <CustomIconButton
          color="info"
          size="small"
          variant="outlined"
          //CS-1071 - Start
          onClick={(e?: React.MouseEvent) => { if (e) e.stopPropagation(); handleActionButtonClick(`orderListActionButton-${row.orderNumber}`, () => handleActionDetails(row)) }}
          //CS-1071 - End
          tooltipMessage="Detail"
          tooltipPlacement="top"
          style={{display: `${hideElement(!canDetailOrder)}`}}
        >
          <ListAltOutlined fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          color="info"
          size="small"
          variant="outlined"
          onClick={(e?: React.MouseEvent) => {
            if (e) e.stopPropagation();
            const source: any = (row as any).originalOrder || row;
            const invoicedItem = (source.orderItems || []).find((item: any) => item?.invoiceId || item?.mfgInvoiceNumber);
            navigate(buildActivityCenterPath({
              tab: "order",
              orderId: source.orderId,
              orderNumber: asEntityNumber(source.orderNumber) || asEntityNumber(source.rawOrderNumber),
              invoiceId: source.invoiceId || invoicedItem?.invoiceId,
              invoiceNumber: asEntityNumber(source.invoiceNumber) || asEntityNumber(invoicedItem?.mfgInvoiceNumber),
            }));
          }}
          tooltipMessage="Activity Center"
          tooltipPlacement="top"
          style={{ display: `${hideElement(!canAccessActivityCenter)}` }}
        >
          <HistoryOutlined fontSize="small" />
        </CustomIconButton>

        {row?.orderStatus !== ORDER_STATUS.PENDING &&( 
        <CustomIconButton
          color="warning"
          size="small"
          variant="outlined"
          //CS-1071 - Start
          onClick={(e?: React.MouseEvent) => { if (e) e.stopPropagation(); handleActionButtonClick(`orderListActionButton-${row.orderNumber}`, () => redirectToTheOrderFulfillment(row)) }}
          //CS-1071 - End
          tooltipMessage="Fulfill"
          tooltipPlacement="top"
          //CS-1717 - Removing inactive product condition 
          style={{
            display: `${hideElement(
              !(canFulfilOrder && row?.orderStatus !== ORDER_STATUS.CANCELED && row.manufacturerName !== 'Migrate Manufacturer')
            )}`,
          }}
        >
          <AssignmentTurnedInOutlined fontSize="small" />
        </CustomIconButton>
        )}
        {row?.orderItems?.some(item => item.productReturnId && (item.productReturnStatus === ORDER_AVAILABILITY.RETURN_INITIATED || item.productReturnStatus === ORDER_AVAILABILITY.RETURN_PENDING)) && (
        <CustomIconButton
          color="error"
          size="small"
          variant="outlined"
          //CS-1071 - Start
          onClick={() => handleActionButtonClick(`orderListActionButton-${row.orderNumber}`, () =>  handleManageReturn(row))}
          //CS-1071 - End
          tooltipMessage="Manage Return"
          tooltipPlacement="top"
          //CS-1717 - Removing inactive product condition
          style={{
            display: `${hideElement(
              !(canManageReturn && row?.orderStatus !== ORDER_STATUS.CANCELED)
            )}`,
          }}
        >
          <AssignmentReturnedOutlined fontSize="small" />
        </CustomIconButton>
        )}
        {/* CS-1322 - Start */}
        {/* CS-1765 - Use top-level purchaseAndBill from order search response instead of manufacturer customConfig */}
        {row?.purchaseAndBill !== "Y" && (
          <CustomIconButton
            color="info"
            size="small"
            variant="outlined"
            //CS-1071 - Start
            onClick={() => handleActionButtonClick(`orderListActionButton-${row.orderNumber}`, () => handleBilling(row))}
            //CS-1071 - End
            tooltipMessage="Apply INV"
            tooltipPlacement="top"
            style={{
              //CS-1591 - Allowed placed order to Apply INV only for superadmin and admin
              display: `${hideElement((
                row.productCategory === PRODUCT_CATEGORY.CONSERVATIVE || !canBillOrder ||
                ((userInfo?.userRole === USER_ROLES.ROLE_ADMIN || userInfo?.userRole === USER_ROLES.ROLE_SUPERADMIN) ? '' : row?.orderStatus !== ORDER_STATUS.DELIVERED) ||
                row.invoiceStatus === "INVOICED" || row.manufacturerName === 'Migrate Manufacturer')
              )}`,
            }}
          >
            <ReceiptLongOutlined fontSize="small" />
          </CustomIconButton>
        )}
        {/* CS-1765 - Use top-level purchaseAndBill from order search response instead of manufacturer customConfig */}
        {row?.purchaseAndBill === "Y" &&(
        <CustomIconButton
          color="info"
          size="small"
          variant="outlined"
          //CS-1071 - Start
          onClick={() =>  handleActionButtonClick(`orderListActionButton-${row.orderNumber}`, () => handleCreateInvoice(row))}
          //CS-1071 - End
          tooltipMessage="Create INV"
          tooltipPlacement="top"
          style={{
            //CS-1591 - Allowed placed order to Apply INV only for superadmin and admin
            display: `${hideElement((
              row.productCategory === PRODUCT_CATEGORY.CONSERVATIVE || !canBillOrder ||
               ((userInfo?.userRole === USER_ROLES.ROLE_ADMIN || userInfo?.userRole === USER_ROLES.ROLE_SUPERADMIN) ? '' : row?.orderStatus !== ORDER_STATUS.DELIVERED) ||
                row.invoiceStatus === "INVOICED" || row.manufacturerName === 'Migrate Manufacturer')
            )}`,
          }}
        >
          <ReceiptLongOutlined fontSize="small" />
        </CustomIconButton>
        )}
        {/* CS-1322 - End */}
        <CustomIconButton
          color="success"
          size="small"
          variant="outlined"
          //CS-1071 - Start
          onClick={() => handleActionButtonClick(`orderListActionButton-${row.orderNumber}`, () =>  handleCancelAndReOrder(row))}
          //CS-1071 - End
          tooltipMessage="Re-Order"
          tooltipPlacement="top"
          style={{
            display: `${hideElement( hideAllActionsForInactiveOrder ||(
              row?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE || !canReOrder || row?.orderStatus !== ORDER_STATUS.PLACED 
              ||  row.manufacturerName === 'Migrate Manufacturer')
            )}`,
          }}
        >
          <ReplayOutlined fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          color="info"
          size="small"
          variant="outlined"
          onClick={(e?: React.MouseEvent) => { if (e) e.stopPropagation(); handleActionButtonClick(`orderListActionButton-${row.orderNumber}`, () => handleEditOutsideOrder(row)) }}
          tooltipMessage="Edit Order"
          tooltipPlacement="top"
          style={{
            display: `${hideElement(!canUpdateOutsideOrder(row))}`,
          }}
        >
          <EditNoteOutlined fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          color="success"
          size="small"
          variant="outlined"
          //CS-1071 - Start
          onClick={(e) => handleActionButtonClick(`orderListActionButton-${row.orderNumber}`, () =>  handleNavigate(row))}
          //CS-1071 - End
          tooltipMessage="Record Tx"
          tooltipPlacement="top"
          //CS-1717 - Removing inactive product condition
          style={{
            display: `${hideElement((
              row.productCategory === PRODUCT_CATEGORY.CONSERVATIVE || !(canTrackOrder && row?.orderStatus === ORDER_STATUS.DELIVERED)
            ))}`,
          }}
        >
          <TroubleshootOutlined fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          color="error"
          size="small"
          variant="outlined"
          //CS-1071 - Start
          onClick={() => handleActionButtonClick(`orderListActionButton-${row.orderNumber}`, () =>  navigate("/returns", { state: { orderDetails: row } }))}
          //CS-1071 - End
          tooltipMessage="Return"
          tooltipPlacement="top"
          //CS-1717 - Removing inactive product condition
          style={{
            display: `${hideElement((
              row.productCategory === PRODUCT_CATEGORY.CONSERVATIVE || !(canReturnOrder && row?.orderStatus === ORDER_STATUS.DELIVERED) ||  row.manufacturerName === 'Migrate Manufacturer'
            ))}`,
          }}
        >
          <UTurnLeftOutlined fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          color="error"
          size="small"
          variant="outlined"
          //CS-1071 - Start
          onClick={() => handleActionButtonClick(`orderListActionButton-${row.orderNumber}`, () =>  handleCancelOrder(row))}
          //CS-1071 - End
          tooltipMessage="Cancel"
          tooltipPlacement="top"
          //CS-1717 - Removing inactive product condition
          style={{
            display: `${hideElement((
              !canCancelOrder || !(
                row?.orderStatus === ORDER_STATUS.PLACED ||
                ((userInfo.entityName === USER_ROLE_ENTITY_NAMES.ADMIN && row?.orderStatus === ORDER_STATUS.PROCESSING && row?.trackingNumber === null) ||
                  (userInfo.entityName === USER_ROLE_ENTITY_NAMES.ADMIN && row?.orderStatus === ORDER_STATUS.PROCESSING))
              ) ||  row.manufacturerName === 'Migrate Manufacturer'
            ))}`,
          }}
        >
          <RemoveShoppingCartOutlined fontSize="small" />
        </CustomIconButton>
        {/* CS-518 */}
        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Order Audit"
          color="warning"
          size="small"
          variant="outlined"
          style={{ display: `${hideElement(!canAuditOrder ||  row.manufacturerName === 'Migrate Manufacturer')}` }}
          //CS-1071 - Start
          onClick={() =>  handleActionButtonClick(`orderListActionButton-${row.orderNumber}`, () => handleClickOrderAudit(row))}
          //CS-1071 - End
        >
          <TrackChanges fontSize="small" />
        </CustomIconButton>
        {/* CS-1302 - Sign Button  */}
         {row?.customConfig?.provider_signature_required === "Y" && row?.orderStatus === ORDER_STATUS.PENDING && row?.canSignOrder === true && (
          <CustomIconButton
            color="warning"
            size="small"
            variant="outlined"
            //CS-1071 - Start
            onClick={() => handleActionButtonClick(`orderListActionButton-${row.orderNumber}`, () => {setShowSignOrderPopup(true) ; setSelectedOrderData(row)})}
            //CS-1071 - End
            tooltipMessage="Sign Order"
            tooltipPlacement="top"
            //CS-1717 - Removing inactive product condition
            style={{
              display: `${hideElement(
               ( row.productCategory !== PRODUCT_CATEGORY.CONSERVATIVE
                || !canSignOrder
                || row?.orderStatus !== ORDER_STATUS.PENDING ||  row.manufacturerName === 'Migrate Manufacturer')
              )}`,
            }}
          >
            <Create fontSize="small" />
          </CustomIconButton>
        )}
        {/* CS-1302 - End */}
      </>
    );
  };

  const handleInvoiceListNavigate = (row: any) => {
    if (row?.invoiceStatus !== "PENDING") {
      // navigate("/invoice_list", { state: { invoiceNumber: row.invoiceNumber } });
      // CS-397 - Insted of Invoice Number , Order Number will be passed
      navigate("/invoice_list", { state: { orderNumber: row.orderNumber, fromDate: "", toDate:"" } });
      //
    }
  };
  // CS-387
  const handleDateRangeChange = (
    fromDate: DateObject | null,
    toDate: DateObject | null
  ) => {
    const fromDateString = fromDate ? fromDate.format("MM/DD/YYYY") : null;
    const toDateString = toDate ? toDate.format("MM/DD/YYYY") : null;
    setValue("fromDate", fromDateString ? fromDateString : "");
    setValue("toDate", toDateString ? toDateString : "");

    setSearchCriteria((prevCriteria) => ({
      ...prevCriteria,
      fromDate: fromDateString || "",
      toDate: toDateString || "",
    }));

    setIsDateRangeChanged(true);
  };
  //

  const handleDateOfService = (
    fromDate: DateObject | null,
    toDate: DateObject | null
  ) => {
    const fromDateString = fromDate ? fromDate.format("MM/DD/YYYY") : null;
    const toDateString = toDate ? toDate.format("MM/DD/YYYY") : null;
    setValue("fromServiceDate", fromDateString ? fromDateString : "");
    setValue("toServiceDate", toDateString ? toDateString : "");
    setIsDateRangeServiceChanged(true);
  };

  const handleShipmentTracking = async (row: OrderInfo) => {
    const response = await dispatch(getOrderTrackingLogs({orderId: row.orderId, trackingNumber: row.trackingNumber}));
    const parsedTrackingInfo = response.payload?.detailedTrackingInfo
    ? JSON.parse(response.payload?.detailedTrackingInfo)
    : null;

      const trackingData = parsedTrackingInfo?.track_info;
      
      const scanEvents = trackingData?.tracking?.providers[0]?.events  || [];
      const dateAndTimes = trackingData?.milestone || [];
      const shippingDateRaw = dateAndTimes.find((d:any) => d.key_stage === "InfoReceived")?.time_iso;
      const departureTimeRaw = dateAndTimes.find((d:any) => d.key_stage === "PickedUp")?.time_iso;
      const timeMetrics = trackingData?.time_metrics;
      const shippingDate = formatShippingTrackingDateTime(shippingDateRaw);
      const departureTime = formatShippingTrackingDateTime(departureTimeRaw);
      const expectedArrivalFrom = formatShippingTrackingDateTime(timeMetrics?.estimated_delivery_date?.from);
      const expectedArrivalTo = formatShippingTrackingDateTime(timeMetrics?.estimated_delivery_date?.to);
      const deliveryEvent = scanEvents.find((event: any) => event.stage === "Delivered");
      const actualDeliveryTime = formatShippingTrackingDateTime(deliveryEvent?.time_iso);
      
    setShipmentInfo({
      show: true,
      orderId: row.orderId,
      orderNumber: row.orderNumber,
      trackingNumber: row.trackingNumber,
      shipping_Info: trackingData,
      status: response.payload.status,
      carrierName: response.payload.carrier,
      shippingDate: shippingDate,
      departureTime: departureTime,
      expectedArrival: expectedArrivalFrom !== "N/A" && expectedArrivalTo !== "N/A"  ? expectedArrivalFrom + " - " + expectedArrivalTo : expectedArrivalFrom !== "N/A" ? expectedArrivalFrom : expectedArrivalTo,
      events: scanEvents,
      milestones: dateAndTimes,
      actualDeliveryTime: actualDeliveryTime
    })

  };

  const handleStatusClick = (event: React.MouseEvent<HTMLElement>, details: any) => {
    const notificationsForOrder = groupedNotifications.get(details.orderId) || [];
    const popupData = notificationsForOrder.map((notif) => ({
      notificationId: notif.notificationId,
      orderNumber: details.orderNumber,
      description: notif.notificationMsg,
      dateTime: notif.auditTimestamp,
    }));

    setNotificationData(popupData);
    setStatusAnchorEl(event.currentTarget);
  };

  const fetchNotificationsForEntities = async () => {
    const orderIdList = orderListInfo?.content?.map(order => order.orderId);
    const data = {
      notificationTypes: accessibleNotifications ? accessibleNotifications : [],
      refEntityIds: orderIdList ? orderIdList : [],
      refEntity: "ORDER"
    };
    if(canAccessNotifications && orderIdList){
      dispatch(fetchNotificationsByRefEntities({ data: data, skipLoader: true }));
    }
  }

  const handleAcknowledge = async (item: any) => {
    try {
      const notificationData = {
        notificationId: item.notificationId,
        comment: ""
      }
      const response = await dispatch(acknowledgeNotification(notificationData)).unwrap();
      if (response.message = "SUCCESS") {
        fetchNotificationsForEntities();
        handleFetchAlerts();
      }
      return response;
    } catch (err) {
      console.error("Failed to fetch wound codes:", err);
      return [];
    }
  }

  const handleFetchAlerts = async () => {
    const data = {
      notificationTypes: accessibleNotifications ? accessibleNotifications: [],
      entity: "ORDER" 
    }
    if(canAccessNotifications){
      const response = await dispatch(fetchAlertEntityNumbers({ data: data, skipLoader: true })).unwrap();
      setTotalNotificationIds(response?.data?.totalNotificationIds)
    }
  }

  useEffect(()=>{
    if(userInfo.notificationEnable && canAccessNotifications &&
      accessibleNotifications && accessibleNotifications.length>0){
      handleFetchAlerts();
    }
  },[accessibleNotifications])
  
  useEffect(() => {
    if (userInfo.notificationEnable) {
      fetchNotificationsForEntities();
    }
  }, [orderListInfo])

  const handleNotification = () => {
    setValue("dateRange", "");
    setIsClearDateRange(true);
    setIsDateRangeChanged(false);
    if (!isAlertOnly) {
      if (location.state != null && location.state.orderListSearchCriteria != null && location.state.orderListSearchCriteria.orderIds?.length > 0) {
        location.state.orderListSearchCriteria = {
          ...location.state.orderListSearchCriteria,
          orderIds: []
        }
      }
      setIsAlertOnly(true);
      fetchInitialLists();
    } else {
      if (location.state != null && location.state.orderListSearchCriteria != null && location.state.orderListSearchCriteria.orderIds?.length > 0) {
        location.state.orderListSearchCriteria = {
          ...location.state.orderListSearchCriteria,
          orderIds: []
        }
      }
      setIsAlertOnly(false);
      fetchInitialLists();
    }
  }

  const groupedNotifications = useMemo(() => {
    const map = new Map<number, any[]>();
    NotificationInfoByRefEntity?.forEach((notif) => {
      const orderId = notif.entityId;
      if (!map.has(orderId)) {
        map.set(orderId, []);
      }
      map.get(orderId)?.push(notif);
    });
    return map;
  }, [NotificationInfoByRefEntity]);


  useEffect(() => {
    const alertedOrderIds = NotificationInfoByRefEntity?.map(notification => notification.entityId);
    if (alertedOrderIds) {
      setAlertedOrderIds(alertedOrderIds);
    }

  }, [NotificationInfoByRefEntity])

  const checkTXStatus = (details: any): boolean => {
    return details.orderItems?.some(
      (item: any) =>
        item.tissueTrackingId == null && item.returnDocumentId == null
    ) ?? false;
  };



  const orderListData: Row[] = useMemo(() => {
    let listData: Row[] = [];
    if (orderListInfo) {
      listData = orderListInfo?.content?.map((details: any) => ({
        // orderNumber: details.orderNumber,
        orderNumber: (
          <Box display="flex" alignItems="center" gap={1}>
             {details.productCategory !== PRODUCT_CATEGORY.CONSERVATIVE &&
              checkTXStatus(details) &&
              details.orderStatus === ORDER_STATUS.DELIVERED && (
              <Tooltip
                  title={
                    <Box
                      sx={{
                        p: 1.5,
                        borderRadius: 2,
                        backgroundColor:
                          theme.palette.mode === "dark"
                            ? "rgba(14, 30, 59, 0.98)"
                            : "rgba(12, 54, 104, 0.96)",
                        border: "none",
                        boxShadow:
                          theme.palette.mode === "dark"
                            ? "0 14px 30px rgba(0, 0, 0, 0.35)"
                            : "0 10px 24px rgba(15, 23, 42, 0.16)",
                        maxWidth: 220,
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#BFDBFE",
                          fontWeight: 700,
                          fontSize: "0.8rem",
                          letterSpacing: "0.04em",
                          mb: 0.5,
                          textTransform: "uppercase",
                        }}
                      >
                        Reminder
                      </Typography>
                      <Typography
                        sx={{
                          color: "#E2E8F0",
                          fontWeight: 500,
                          lineHeight: 1.6,
                          fontSize: "0.82rem",
                        }}
                      >
                        Record Tx is required for this order.
                      </Typography>
                    </Box>
                  }
                  arrow
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        border: "none",
                        p: 0,
                        color: "inherit",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "transparent",
                      },
                    },
                  }}
                >
                  <Box
                    role="button"
                    onClick={(e) => e.stopPropagation()} // CS-1555
                    sx={{
                      position: "relative",
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      backgroundColor: "#a6ff2aff",
                      cursor: "pointer",
                      "&::after": {
                        content: '""',
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                        border: "1px solid #a6ff2aff",
                        animation: "pulse 2.5s infinite ease-in-out",
                        top: 0,
                        left: 0,
                      },
                      "@keyframes pulse": {
                        "0%": {
                          transform: "scale(1)",
                          opacity: 1,
                        },
                        "100%": {
                          transform: "scale(3)",
                          opacity: 0,
                        },
                      },
                    }}
                  />
              </Tooltip>
            )}
            <Typography variant="body2" sx={{ display: "inline-block" }}>
              {/* CS-1406 - Rendering order number with link*/}
              {details.orderNumber !== null && canDetailOrder ? (
                <Link
                  component="button"
                  underline="hover"
                  variant="body2"
                  // CS-1555 - Start
                  onClick={(e) => {
                    e.stopPropagation();
                    handleActionButtonClick(
                      `orderListActionButton-${details.orderNumber}`,
                      () => handleActionDetails(details)
                    );
                  }}
                  // CS-1555 - End
                  color={'#00B8D9'}
                >
                  {details.orderNumber}
                </Link>
              ) : (
                details.orderNumber
              )}
            </Typography>
            {details.isUpfrontOrder && (
              <BoltOutlined
                sx={{ fontSize: 20, color: "#00E5B0" }}
                titleAccess="Upfront Order"
              />
            )}
          </Box>
        ),
        rawOrderNumber: details.orderNumber, // CS-1517
        orderNumberId: details.orderNumber,
        practiceName: details.practiceName,
        patientName: (details.patientName || details.orderInfo?.patient) ? (details.patientName || details.orderInfo?.patient) : '---',
        //CS-1564 - Updated the manufacturer name display logic to show INACTIVE manufacturers correctly
        manufacturerName:
          details.manufacturerName !== 'Migrate Manufacturer'
            ? (
              details?.manufacturerInactiveDate &&
                dayjs(details.manufacturerInactiveDate).isBefore(dayjs(), 'day')
                ? `${details.manufacturerName} (INACTIVE)`
                : details.manufacturerName
            )
            : '---',
        manufacturerId: details.manufacturerId,
        customConfig:details.customConfig,
        //CS-1564 - Updated the product name display logic to show INACTIVE products correctly
        productName:
          details.productName !== 'Migrate Product'
            ? (
                details.productCategory === PRODUCT_CATEGORY.CONSERVATIVE 
                ? getCategoryDisplayLabel(allCodeTablesValuesMap, details.productCategory)
                : details.productName
            )
            : '---',
        providerName: (details.providerName || details.orderInfo?.provider) ? (details.providerName || details.orderInfo?.provider) : '---',
        orderDate: formatDate(details.orderDate),
        dateOfService: formatDate(details.dateOfService),
        orderType: details.orderType,
        orderStatus: (
          <Box display="flex" alignItems="center" gap={1}>
            {userInfo.notificationEnable && alertedOrderIds.includes(details.orderId) && (
              <Box
                onClick={(e) => {
                  e.stopPropagation();
                  handleStatusClick(e, details);
                }}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: "#2196f3",
                  display: "inline-block",
                  cursor: "pointer",
                }}
              />
            )}
            <Typography
              variant="body2"
              sx={{
                display: "inline-block",
                color: `${getStatusColor(details.orderStatus)} !important`,
                fontWeight: 600,
              }}
            >
              {details.orderStatus}
            </Typography>
          </Box>
        ), 
         
        productCategory: details.productCategory,
        trackingNumber: details.trackingNumber ? <>
        <Tooltip title="Track Order" placement="top" arrow>
          <Link
            component="button"
            underline="hover"
            variant="body2"
            // CS-1555 - Start
            onClick={(e) => {
              e.stopPropagation();
              handleActionButtonClick(
                `orderListActionButton-${details.orderNumber}`,
                () => handleShipmentTracking(details)
              );
            }}
              // CS-1555 - End
            color={colors.warning[300]}
          >
            <LocalShippingOutlined />
          </Link>
        </Tooltip>
      </> 
      : "",
        invoiceStatus:
          details.invoiceStatus !== "PENDING" ? (
            <Link
              component="button"
              underline="hover"
              variant="body2"
              // CS-1555 - Start
              onClick={(e) => {
                e.stopPropagation();
                handleActionButtonClick(
                  `orderListActionButton-${details.orderNumber}`,
                  () => handleInvoiceListNavigate(details)
                );
              }}
              // CS-1555 - End
              color={colors.info[300]}
            >
              {/* CS-397 Start- Removed the invoice number  */}
              {`${details.invoiceStatus}`}
              {/* CS-397 End */}
            </Link>
          ) : (
            details.invoiceStatus || ""
          ),
        shippingCarrier: details.shippingCarrier,
        isStrikethrough : details.isStrikethrough,
        canSignOrder:details?.canSignOrder,
        originalOrder: details, // CS-1555,
        // CS-1564 : Add inactive data to row object
        productInactiveDate: details?.productInactiveDate,
        manufacturerInactiveDate: details?.manufacturerInactiveDate,
        action: actionComponent(details)
      }));
    }
    return listData;
  }, [orderListInfo, alertedOrderIds, theme.palette.mode]);

  const legacyItems = [
    { icon: <UTurnLeftOutlined color="error" />, text: "Return" },
    { icon: <TroubleshootOutlined color="success" />, text: "Tracking" },
    { icon: <VisibilityOutlined color="info" />, text: "Preview" },
    { icon: <ListAltOutlined color="info" />, text: "Detail" },
    { icon: <AssignmentTurnedInOutlined color="warning" />, text: "Fulfill" },
  ];

  const handleExport = (exportType: string) => {
    const searchCriteriaFromStorage = getSearchCriteriaFromSessionStorage(
      CAN_ACCESS_APPLICATION.ORDER_MANAGEMENT +
        "SearchCriteria" +
        userInfo.userId
    );

    if (searchCriteriaFromStorage) {
      let dataToSearch = {
        ...searchCriteria,
        currentPage: searchCriteriaFromStorage.currentPage,
        downloadState: true,
      };
      if (!dataToSearch.practiceIds || dataToSearch.practiceIds.length === 0) {
        dataToSearch.practiceIds =
        practiceByUserRoleOrderSlicenew &&
        practiceByUserRoleOrderSlicenew.length > 0
            ? practiceByUserRoleOrderSlicenew?.map((practice) =>
                Number(practice.practiceId)
              )
            : [];
      }
      if (!dataToSearch.productIds || dataToSearch.productIds.length === 0) {
        dataToSearch.productIds =
        filteredeProductsByUserRoleOrderSlice &&
        filteredeProductsByUserRoleOrderSlice.length > 0
            ? filteredeProductsByUserRoleOrderSlice?.map((product) =>
                Number(product.productId)
              )
            : [];
      }
      if (!dataToSearch.manufacturerIds || dataToSearch.manufacturerIds.length === 0) {
        dataToSearch.manufacturerIds =
          manufacturerInfoList &&
          manufacturerInfoList.length > 0
            ? manufacturerInfoList?.map((manufacturer) =>
                Number(manufacturer.manufacturerId)
              )
            : [];
      }
      if (!dataToSearch.status || dataToSearch.status.length === 0) {
        dataToSearch.status =
          statusOptions && statusOptions.length > 0
            ? statusOptions?.map((status) => status.value)
            : [];
      }
      if (!dataToSearch.orderItemStatus || dataToSearch.orderItemStatus.length === 0) {
        dataToSearch.orderItemStatus =
          availabilityOptions && availabilityOptions.length > 0
            ? availabilityOptions?.map((status) => status.value)
            : [];
      }
      if (
        !dataToSearch.invoiceStatus ||
        dataToSearch.invoiceStatus.length === 0
      ) {
        dataToSearch.invoiceStatus =
          orderInvoiceStatusOptions && orderInvoiceStatusOptions.length > 0
            ? orderInvoiceStatusOptions?.map((status) => status.value)
            : [];
      }

      switch (exportType) {
        case "searchList":
          ExportToExcel(
            dataToSearch,
            columns,
            dispatch,
            EXPORTABLE_ITEMS.ORDER
          );
          break;
        case "salesSheet":
          ExportToExcel(
            dataToSearch,
            columns,
            dispatch,
            EXPORTABLE_ITEMS.ORDER_SSV
          );
          break;
      }
    }
  };

  const handleRecordPastOrderPopup = () => {
    setShowRecordPastOrderPopup(!showRecordPastOrderPopup);
  }

  const navigateRecordPastOrder = () => {
    navigate("/order", {
      state: {
        orderType: ORDERTYPE.PAST_ORDER,
      },
    });
  }

  // 06/28/2025 - Prod Bug Fix  : Fetching active practice providers data by passing multiple practiceIds
  useEffect(() => {
    const sortedPracticeInfo: PracticeInfo[] = sortNames(
      practiceByUserRoleOrderSlicenew,
      "practiceName"
    );
    const practiceIds = sortedPracticeInfo.map(
      (practice) => Number(practice.practiceId)
    );
    const fetchProviders = async() =>{
      if (practiceIds.length > 0) {
        const data = { practiceIds: practiceIds, onlyActiveRecords: false }
        const res = await dispatch(fetchActivePracticeProviders({ data: data, skipLoader: true }));
      }  
    }
    fetchProviders();
  }, [practiceByUserRoleOrderSlicenew]);

  //CS-1302 - Start
  const practiceProviderList = useMemo(() => {
  let options: { label: string; value: any }[] = [];

  if (!Array.isArray(practiceProvidersInfo)) return options;

  const filteredProviders =
    watchedPracticeIds?.length > 0
      ? practiceProvidersInfo.filter((provider) =>
          watchedPracticeIds.includes(Number(provider.practiceId))
        )
      : practiceProvidersInfo;

  // If ROLE_PROVIDER, restrict to that specific provider
  if (userInfo?.entityName === USER_ROLE_ENTITY_NAMES.PROVIDER) {
    const matchedProvider = filteredProviders.find(
      (provider) =>
        provider.firstName === userInfo.firstName &&
        provider.lastName === userInfo.lastName
    );

    if (matchedProvider) {
      options.push({
        label: `${matchedProvider.title ? matchedProvider.title + " " : ""}${matchedProvider.firstName} ${
          matchedProvider.middleName ? matchedProvider.middleName + " " : ""
        }${matchedProvider.lastName}`,
        value: matchedProvider.firstName,
      });
      setValue("providerName", options[0].value); 
    }
  } else {
    // Normal list for non-provider roles
    filteredProviders.forEach((item) => {
      options.push({
        label: `${item.title ? item.title + " " : ""}${item.firstName} ${
          item.middleName ? item.middleName + " " : ""
        }${item.lastName}`,
        value: item.firstName,
      });
    });
  }

  return options;
}, [practiceProvidersInfo, watchedPracticeIds, userInfo]);
//CS-1302 - End

const totalRecords = orderListInfo?.totalElements ?? 0;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        px: { xs: 1, md: 3 },
        py: 2,
      }}
    >
      {/*   CS-793  */}
      {showCreateOrderPopup.show &&
        <InfoPopup
          open={showCreateOrderPopup.show}
          content={showCreateOrderPopup.message}
          onClose={() => setCreateOrderPopup({ message: "", show: false, title: "" })}
          severity="info"
          confirmButton={"OK"}
          onConfirm={() => {navigate('/patients')}}
          title={showCreateOrderPopup.title}
        />
      }
      {showIVRListPopup && (
  <CreateOrderIVRListPopup
    open={showIVRListPopup}
    onClose={handleClose}
  />
)}
      <OrderProductModal
        open={orderModalOpen}
        onClose={() => setOrderModalOpen(false)}
      />
      {showPDF.isShow && (
        <PDFViewer
          isOpen={showPDF.isShow}
          onClose={() =>
            setShowPDF({ isShow: false, productName: "", fileName: "" })
          }
          title={showPDF.productName}
          fileName={showPDF.fileName}
          base64String={orderDocumentInfo?.content || ""}
        />
      )}
      {isConfirmationOpen && (
        <OptionsPopup
          open={isConfirmationOpen}
          onClose={() => handleCloseCancelOrderConfirmation()}
          variant="confirm"
          message="Do you really want to cancel this order?"
          buttons={[
            {
              name: "Confirm",
              color: "primary",
              onClick: () => handleCancelOrderConfirmation(),
            },
            {
              name: "Cancel",
              color: "secondary",
              onClick: () => setIsConfirmationOpen(false),
            },
          ]}
        />
      )}

      {/* -- Filter panel -- */}
      <Box sx={{ position: "relative", zIndex: 20, overflow: "visible" }}>
        <Collapse in={showCard} ref={filterPanelRef} onEntering={handleFilterPanelEntering} onEntered={handleFilterPanelEntered} onExited={handleFilterPanelExited}>
          <Card sx={filterPanelSx}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={2} alignItems="center">
                <Grid item md={3} xs={12}>
                  <CustomMultipleDropDown
                    name="practiceIds"
                    label="Practice"
                    placeholderText="Select practice"
                    disabled={practiceByUserRoleOrderSlicenew?.length === 1}
                    options={practiceOptions}
                    control={control}
                    size="small"
                  />
                </Grid>
                {/* CS-905 */}
                <Grid item md={3} xs={12}>
                  <CustomTextField
                    control={control}
                    controllerName="patientFirstName"
                    label="Patient First Name"
                    placeholder="Enter first name"
                    size="small"
                    
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <CustomTextField
                    control={control}
                    controllerName="patientLastName"
                    label="Patient Last Name"
                    placeholder="Enter last name"
                    size="small"
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <CustomMultipleDropDown
                    label="Manufacturer"
                    name="manufacturerIds"
                    placeholderText="Select manufacturer"
                    options={manufacturesList}
                    control={control}
                    size="small"
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <CustomMultipleDropDown
                    label="Product"
                    name="productIds"
                    placeholderText="Select product"
                    options={productOptions}
                    control={control}
                    size="small"
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <CustomTextField
                    control={control}
                    controllerName="orderNumber"
                    label="Order ID"
                    placeholder="Enter order ID"
                    size="small"
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <CustomTextField
                    control={control}
                    controllerName="invoiceNumber"
                    label="Invoice Number"
                    placeholder="Enter invoice number"
                    size="small"
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <CustomTextField
                    controllerName="serialNumber"
                    control={control}
                    name="serialNumber"
                    label="Serial Number"
                    placeholder="Enter serial number"
                    size="small"
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <CustomDropdownField
                    control={control}
                    name="providerName"
                    label="Provider"
                    placeholderText="Select provider"
                    options={practiceProviderList}
                    disabled={userInfo?.entityName === USER_ROLE_ENTITY_NAMES.PROVIDER}
                    size="small"
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  {filterApplied}
                  <CustomDateRange
                    label="Order Date Range"
                    control={control}
                    controllerName="dateRange"
                    onChange={handleDateRangeChange}
                    dateRangeMonths={process.env.REACT_APP_REST_SERVICE_URL?.includes('demo') ? undefined : filterApplied ? undefined : 6}
                    onClear={isClearDateRange}
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <CustomDateRange
                    control={control}
                    controllerName="dateOfService"
                    label="Date Of Service"
                    onChange={handleDateOfService}
                    onClear={isClearDateRange}
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <CustomMultipleDropDown
                    name="status"
                    label="Order Status"
                    placeholderText="Select status"
                    options={statusOptions}
                    control={control}
                    size="small"
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <CustomMultipleDropDown
                    name="orderItemStatus"
                    label="Order Item Status"
                    placeholderText="Select item status"
                    options={availabilityOptions}
                    control={control}
                    size="small"
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <CustomMultipleDropDown
                    name="invoiceStatus"
                    label="Invoice Status"
                    placeholderText="Select invoice status"
                    options={orderInvoiceStatusOptions}
                    control={control}
                    size="small"
                  />
                </Grid>
                {userInfo?.entityName === USER_ROLE_ENTITY_NAMES.PRACTICE ? "" :
                  <>
                    <Grid item md={3} xs={12}>
                      <CustomDropdownField
                        name="withoutIvr"
                        label="IVR File Location"
                        placeholderText="Select Select ivr file location"
                        options={includeIvrOptions}
                        control={control}
                        size="small"
                      />
                    </Grid>
                  </>
                }
                <Grid item md={2} xs={12}>
                  <Button
                    fullWidth
                    size="large"
                    startIcon={<SearchOutlined />}
                    sx={{ ...primaryActionBtnSx, height: "42px", py: 0 }}
                    type="submit"
                    removeUpperCase
                  >
                    Search
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Card>
        </Collapse>
      </Box>

      {/* -- Main list card -- */}
      <Box mt={2} sx={{ position: "relative", zIndex: 1 }}>
        <Card sx={{ ...listCardSx, p: { xs: "14px !important", md: "18px !important" } }}>
          <Grid
            container
            justifyContent="flex-end"
            alignItems="center"
            spacing={1.2}
            mb={1}
          >
            <Grid item xs={12} md>
              <Typography variant="h3" fontWeight={800} color="text.primary">Order List</Typography>
            </Grid>
            {canAccessNotifications && userInfo.notificationEnable
              && totalNotificationIds && totalNotificationIds.length > 0 ? (
              <Grid item xs={12} md="auto">
                <CustomIconButton
                  color="warning"
                  variant="contained"
                  tooltipMessage="Order Notifications"
                  size="small"
                  notifyCount={totalNotificationIds?.length}
                  onClick={handleNotification}
                >
                  {isAlertOnly ?
                    <Notifications />
                    :
                    <NotificationsOutlined />
                  }
                </CustomIconButton>
              </Grid>
            ) : null}
            <Grid item xs={12} md="auto">
              <Button
                variant="outlined"
                color="info"
                onClick={toggleFilterPanel}
                startIcon={<SearchOutlined />}
                fullWidth
                sx={outlineBtnSx}
                removeUpperCase
              >
                {showCard ? "Hide Filters" : "Show Filters"}
              </Button>
            </Grid>
            {canCreateOrder && (
             <Grid item xs={12} md="auto">
              <Button
                fullWidth
                color="info"
                startIcon={<ShoppingCartOutlined />}
                onClick={() => setOrderModalOpen(true)}
                sx={primaryActionBtnSx}
                removeUpperCase
              >
                Place Order
              </Button>
            </Grid>
            )}
            {canCreateConsignmentOrder &&
              <Grid item xs={12} md="auto">
                <Button
                  fullWidth
                  color="warning"
                  startIcon={<AppRegistrationOutlined />}
                  onClick={() =>
                    navigate("/order", {
                      state: { orderType: ORDERTYPE.CONSIGNMENT_ORDER },
                    })
                  }
                  sx={primaryActionBtnSx}
                  removeUpperCase
                >
                  Create Consignment Order
                </Button>
              </Grid>
            }
            {canRecordPastOrder &&
              <Grid item xs={12} sm="auto">
                <Button
                  fullWidth
                  color="secondary"
                  startIcon={<ContentPasteOutlined />}
                  onClick={() => navigateRecordPastOrder()}
                  sx={filledTealBtnSx}
                  removeUpperCase
                >
                  Record Order
                </Button>
              </Grid>
            }
            {/* <Grid item xs={12} sm="auto">
                <Button
                  fullWidth
                  color="secondary"
                  startIcon={<ContentPasteOutlined />}
                  onClick={() =>navigate("/past_order")}
                  sx={primaryActionBtnSx}
                  removeUpperCase
                >
                  Outside Platform Orders
                </Button>
              </Grid> */}
            {canExportList &&
              <Grid item sm="auto">
                {!isMobile &&
                  (<Button
                    id="customized-button"
                    aria-controls={Boolean(anchorElMenu) ? "customized-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={Boolean(anchorElMenu) ? "true" : undefined}
                    variant="outlined"
                    disableElevation
                    onClick={handleMenuClick}
                    startIcon={<ExitToApp />}
                    sx={exportBtnSx}
                    removeUpperCase
                    endIcon={
                      <Box
                        component="span"
                        sx={{
                          display: "flex",
                          transition: "transform 0.3s ease",
                          transform: anchorElMenu ? "rotate(180deg)" : "rotate(0deg)",
                          padding: "2px",
                        }}
                      >
                        <KeyboardArrowDown />
                      </Box>
                    }
                  >
                    Export
                  </Button>)
                }
              </Grid>
            }
          </Grid>

          {canExportList &&
            <Box>
              <Box position="absolute" mt={1}>
                {isMobile &&
                  (<Button
                    color="success"
                    variant="text"
                    onClick={(event) => handleMenuClick(event)}
                    startIcon={<DownloadOutlined fontSize="small" />}
                    sx={exportBtnSx}
                    removeUpperCase
                  >
                    Export
                  </Button>)
                }
              </Box>
              <Box>
                <StyledMenu
                  id="customized-menu"
                  MenuListProps={{ "aria-labelledby": "customized-button" }}
                  anchorEl={anchorElMenu}
                  open={Boolean(anchorElMenu)}
                  onClose={handleMenuClose}
                  slotProps={{
                    paper: {
                      sx: {
                        width: "260px",
                        maxWidth: "90vw",
                        mt: 0.75,
                        p: 0.75,
                        borderRadius: "12px",
                        border: `1px solid ${isDark ? "rgba(0,184,217,0.3)" : "rgba(0,184,217,0.22)"}`,
                        backgroundColor: isDark ? "#141720" : "#ffffff",
                        backgroundImage: "none",
                        boxShadow: isDark
                          ? "0 18px 42px rgba(0,0,0,0.45)"
                          : "0 14px 32px rgba(15,23,42,0.14)",
                      },
                    },
                  }}
                >
                  <Box sx={{ px: 1, mb: 1 }}>
                    <Button
                      fullWidth
                      variant="outlined"
                      startIcon={<CloudDownload />}
                      onClick={() => handleExport("searchList")}
                      disabled={totalRecords > 1000}
                      sx={exportMenuItemBtnSx}
                      removeUpperCase
                    >
                      Export Search List
                    </Button>
                  </Box>

                  {canAccessExportSSDetail && (
                    <Box sx={{ px: 1, mb: 1 }}>
                      <Button
                        fullWidth
                        variant="outlined"
                        startIcon={<CloudDownload />}
                        onClick={() => handleExport("salesSheet")}
                        disabled={totalRecords > 1000}
                        sx={exportMenuItemBtnSx}
                        removeUpperCase
                      >
                        Export Details List
                      </Button>
                    </Box>
                  )}

                  {totalRecords > 1000 && (
                    <Box
                      sx={{
                        mx: 1,
                        p: 1.5,
                        mt: 1,
                        backgroundColor: "warning.light",
                        borderRadius: 1,
                        color: "warning.contrastText",
                      }}
                    >
                      <Typography variant="body2">
                        Export is available only when the list contains 1,000 records or fewer.
                        Maximum export size: 1000 records.
                      </Typography>
                    </Box>
                  )}
                </StyledMenu>
              </Box>
            </Box>
          }

          <Table
            columns={columns}
            rows={orderListData}
            actionComponent={(row: OrderInfo) => actionComponent(row)}
            emptyText="No Orders Found"
            totalPages={orderListInfo?.totalPages}
            totalElementText={
              "Records: " +
              ((orderListInfo?.totalElements)
                ? orderListInfo?.totalElements
                : "0")
            }
            pageNumber={handlePagination}
            currentPageNumber={searchCriteria.currentPage - 1}
            showMenu={true}
            sortableColumns={orderListSort.sortableColumns}
            serverSideSorting
            onSortChange={handleTableSort}
            controlledSortColumn={orderListSort.controlledColumn(searchCriteria.sortBy)}
            controlledSortOrder={searchCriteria.sortOrder ?? null}
            // CS-1071 - Start
            currentPageKey={"orderList"}
            uniqueValue="orderNumberId"
            activeButtonId={activeButtonId}
            // CS-1071 - End
            // CS-1555 - Start
            openMenuOnRowClick={true}
            onRowClick={handleRowClick}
            clickableCards={true}
            // CS-1555 - End
            sx={orderTableSx}
          />
        </Card>
      </Box>

      <RecordPastOrderPopup onClose={handleRecordPastOrderPopup} open={showRecordPastOrderPopup}/>
      <ShipmentInfoPopup
        open={shipmentInfo.show}
        onClose={() => setShipmentInfo({
            show: false,
            orderId: 0,
          orderNumber: '',
          trackingNumber: '',
          shipping_Info: '',
          status: '',
          carrierName: '',
          shippingDate: '',
          departureTime: '',
          expectedArrival: '',
            events: [],
            milestones: [],
          actualDeliveryTime: ''
        })}
        trackingNumber={shipmentInfo?.trackingNumber || ""}
        orderId={shipmentInfo?.orderId || 0}
        orderNumber={shipmentInfo?.orderNumber || "-"}
        shipper={{
          city: shipmentInfo?.shipping_Info?.shipping_info?.shipper_address?.city || "",
          state: shipmentInfo?.shipping_Info?.shipping_info?.shipper_address?.state || "",
          postal_code: shipmentInfo?.shipping_Info?.shipping_info?.shipper_address?.postal_code || "",
        }}

        recipient={{
          city: shipmentInfo?.shipping_Info?.shipping_info?.recipient_address?.city || "",
          state: shipmentInfo?.shipping_Info?.shipping_info?.recipient_address?.state || "",
          postal_code: shipmentInfo?.shipping_Info?.shipping_info?.recipient_address?.postal_code || "",
        }}
        status={shipmentInfo?.status || ""}
        carrierName={shipmentInfo?.carrierName || ""}
        shippingDate={shipmentInfo.shippingDate}
        departureTime={shipmentInfo.departureTime}
        expectedArrival={shipmentInfo?.status === "Delivered" ? shipmentInfo.actualDeliveryTime : shipmentInfo.expectedArrival }
        events={shipmentInfo.events}
        milestones={shipmentInfo.milestones.map((d: any) => d.type)}
      />
      {userInfo.notificationEnable &&
        <StatusInfoPopup
          anchorEl={statusAnchorEl}
          onAcknowledge={handleAcknowledge}
          onClose={() => {
            setStatusAnchorEl(null)
          }
          }
          rows={notificationData}
        />
      }
      {
        showSignOrderPopup &&
        <SignOrderPopup
          open={showSignOrderPopup}
          onClose={() => {setShowSignOrderPopup(false); setSelectedOrderData(null); dispatch(fetchOrdersList({data: searchCriteria, skipLoader: false}))}}
          orderData = {selectedOrderData}
        />
      }
    </Box>
  );
};

export default OrderList;